import React, { Component, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import {getChannel} from 'postal';
import { styled, useTheme } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import SplitPane, { Pane } from 'split-pane-react-uxrd';
import 'split-pane-react-uxrd/esm/themes/default.css';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ClearIcon from '@mui/icons-material/Clear';
import UndoIcon from '@mui/icons-material/Undo';
import CloseIcon from '@mui/icons-material/Close';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import SearchIcon from '@mui/icons-material/Search';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InputAdornment from '@mui/material/InputAdornment';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import ReplayIcon from '@mui/icons-material/Replay';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import OutputIcon from '@mui/icons-material/Output';
import TextField from '@mui/material/TextField';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { InternalLinkChooserDialog, ExternalLinkChooserDialog } from "../../document/link-chooser";
import { ContentInclusionDialog, ChooseFootnoteDialog, ChooseDocumentUnitDialog} from "../../document/document-runtime";
import { ChallengeResponsePanel, GotoChecklistPanel, GotoStepPanel } from "../../document/document-qrh";
import { TableEntryPanel, CreateTableDialog } from "../../document/document-table";
import { AnnotationsPanel } from "../../document/document-annotations";
import { MediaFileChooser } from "../../graphics/catalog";

import debounce from 'lodash.debounce';
import { v4 as uuidv4 } from 'uuid';
import { ColorPickerDialog  } from "../../util/color";
import { validHex, color, hexToXY, xyToRgb } from '@uiw/color-convert';

import { UserInfo, netGet, netPost, netPostExt, netFetch, keycloak } from "../../network";
import { WorkflowInstance } from "../../workflow/workflow";
import WorkflowFrontModule from "../../workflow/workflow-front";
import { addInstance, removeInstance, saveAction, closeAction, resetInstances, setCurrentInstance } from "../../../features/xeditor/xeditorSlice";
import { setWorkList, setWorkInstance } from "../../../features/menu/menuSlice";

import * as XUI from '../xxeclient/xui.js';
import * as XXE from '../xxeclient/xxeclient.js';
import { XMLEditorWrapper } from "./wrapper";

// import * as DB from '../xxeclient/docbook.js';
// some issue with latest react if these are in other folder, something odd with relative paths,
// so moved all resources from ../xxeclient

import './xui.css';
import './xxeclient.css';
import './docbook.css';

const postal = getChannel('ucs');

const MY_MENU_NAME = "workfront";

/* Content inclusions based on document target profile */
const GEN_INCLUSIONS = [
  { value: 'RevisionHighlights', label: 'Revision Highlights' },
  { value: 'RevisionRecord', label: 'Revision Record' },
  { value: 'RevisionStatus', label: 'Revision Status' },
  { value: 'Summary', label: 'Chapter Summary List' },
  { value: 'LES', label: 'List of Effective Sections' },
  { value: 'TOC', label: 'Table of Contents' },
];

const QRH_INCLUSIONS = [
  { value: 'RevisionHighlights', label: 'Revision Highlights' },
  { value: 'RevisionRecord', label: 'Revision Record' },
  { value: 'RevisionStatus', label: 'Revision Status' },
  { value: 'AircraftModelTable', label: 'Aircraft Model Table'},
];

var globalInstances = [];
var globalConfirmInstances = [];
var allGlobalInstances = [];
var globalNoCloseWindow = false;
var globalConfirmResult = false;
var globalConfirmReceived = false;

postal.subscribe(
  'app.xmleditor.save.confirmed',
  (envelope) => {
    globalConfirmResult = envelope.payload.confirmed;
    globalConfirmReceived = true;
  }
);

const waitUntilCondition = (conditionFunction) => {
  const poll = resolve => {
    if (conditionFunction()) resolve();
    else setTimeout(_ => poll(resolve), 400);
  }
  return new Promise(poll);
};

const xmlEditorCloseCallback = () => {

  return new Promise((resolve, reject) => {
    globalNoCloseWindow = true;
    globalConfirmResult = true;
    globalConfirmReceived = false;
    postal.publish('app.xmleditor.tabs.close', {close: true});
    waitUntilCondition(_ => globalConfirmReceived == true )
      .then(() => {
        if ( globalConfirmResult ) {
          resolve(globalConfirmResult);
        } else {
          reject('canceled');
        }
      });

  });
};

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function decimalToHexString(number, padding)
{
  if (number < 0)
  {
    number = 0xFFFFFFFF + number + 1;
  }

  let hex = number.toString(16).toUpperCase();
  padding = typeof (padding) === "undefined" || padding === null ? 2 : padding;

  while (hex.length < padding) {
    hex = "0" + hex;
  }

  return hex;
}

function getRandomKey8() {
  const n = getRandomInt(0xFFFFFFFF);
  return decimalToHexString(n, 8);
}

function getRandomKey7() {
   const n = getRandomInt(0xFFFFFFF);
  return decimalToHexString(n, 7);
}

const convertColor = (value) => {
  if (validHex(value)) {
    const c = color(value).rgb;
    return `(r:${c.r}, g:${c.g}, b:${c.b})`;
  }
  return '';
};

/**
  * Style property formatted as CSS style
  * color is legacy color
  **/
const getStyleProperty = (style, prop, color) => {
  if (prop === 'color' && color && !style) {
    return color;
  }
  if (!style && prop === 'color') {
    return '#000000';
  }
  if (!style && prop === 'background-color') {
    return '#FFFFFF';
  }
  if (!style) {
    return undefined;
  }
  const ss = style.split(';');
  for (let i = 0; i < ss.length; i++) {
    const s = ss[i].trim();
    if (s && s.length > 0) {
      const sv = s.split(':');
      if (sv.length > 1) {
        const name = sv[0].trim();
        if (name === prop) {
          return sv[1].trim();
        }
      }
    }
  }
  if (prop === 'color' && color) {
    return color;
  }
  if (prop === 'color') {
    return '#000000';
  }
  if (prop === 'background-color') {
    return '#FFFFFF';
  }
  return undefined;
}

const parseStyleProperty = (style) => {
    const props = {};
    if ( !style ) {
      return props;
    }
    const ss = style.split(';');
    for(let i=0; i<ss.length; i++) {
      const s = ss[i].trim();
      if ( s && s.length > 0 ) {
        const sv = s.split(':');
        if ( sv.length > 1 ) {
          const name = sv[0].trim();
          const value = sv[1].trim();
          props[name] = value;
        }
      }
    }
    return props;
  }

  const formatStyleProperty = (props) => {
    let f = '';
    for(const p in props) {
      f += `${p}: ${props[p]};`;
    }
    return f;
  };

  

// const LazyEditor = React.lazy(() => import('../xxeclient/xxeclient.js'));


const SAMPLE1 = 
`<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE article PUBLIC "-//OASIS//DTD DocBook XML V4.5//EN"
"http://www.oasis-open.org/docbook/xml/4.5/docbookx.dtd">
<article lang="en-US" status="draft">
  <title>DocBook Table Support</title>

  <sect1 id="examples">
    <title>Examples found in <citetitle>DocBook: The Definitive
    Guide</citetitle></title>

    <table frame="all">
      <title>Sample Table</title>

      <tgroup align="left" cols="5" colsep="1" rowsep="1">
        <colspec colname="c1"/>

        <colspec colname="c2"/>

        <colspec colname="c3"/>

        <colspec colname="c5" colnum="5" colwidth="2*"/>

        <spanspec align="center" nameend="c2" namest="c1" spanname="hspan"/>

        <spanspec align="center" nameend="c3" namest="c2" spanname="bspan"/>

        <thead>
          <row>
            <entry spanname="hspan">Horizontal Span</entry>

            <entry>a3</entry>

            <entry>a4</entry>

            <entry>a5</entry>
          </row>
        </thead>

        <tfoot>
          <row>
            <entry>f1</entry>

            <entry>f2</entry>

            <entry>f3</entry>

            <entry>f4</entry>

            <entry>f5</entry>
          </row>
        </tfoot>

        <tbody>
          <row>
            <entry>b1</entry>

            <entry>b2</entry>

            <entry>b3</entry>

            <entry>b4</entry>

            <entry morerows="1" valign="middle"><para><!--Pernicous Mixed Content-->
            Vertical Span</para></entry>
          </row>

          <row>
            <entry>c1</entry>

            <entry morerows="1" spanname="bspan" valign="bottom">Span
            Both</entry>

            <entry>c4</entry>
          </row>

          <row>
            <entry>d1</entry>

            <entry>d4</entry>

            <entry>d5</entry>
          </row>
        </tbody>
      </tgroup>
    </table>

    <informaltable frame="none">
      <tgroup cols="2">
        <colspec colwidth="0.5in"/>

        <colspec colwidth="0.5in"/>

        <tbody>
          <row>
            <entry>1</entry>

            <entry>1</entry>
          </row>

          <row>
            <entry>2</entry>

            <entry>4</entry>
          </row>

          <row>
            <entry>3</entry>

            <entry>9</entry>
          </row>
        </tbody>
      </tgroup>
    </informaltable>
  </sect1>

</article>
`;



const SAMPLE3 =
`<?xml version="1.0" encoding="utf-8"?>
<supplement>
  <header>
    <model>B787</model>
    <applicableTo>FCOM</applicableTo>
    <number>B787 24/19</number>
    <cancelling>N/A</cancelling>
    <effectiveDate>September 13, 2024</effectiveDate>
  </header>
  <title>Leading Edge Outboard Slat Actuator Upgrade</title>
  <sectionLevel1>
    <title>Purpose</title>
    <para>To advise flight crew that aircraft upgraded with new leading edge
    outboard slat lockout actuators (LEOLAs) no longer require the flaps and
    slats to remain extended after landing under certain conditions.</para>
  </sectionLevel1>
  <sectionLevel1>
    <title>Background</title>
    <para>An FAA AD was issued after several leading edge outboard slat geared
    rotary actuators (GRAs) failed after the flaps were retracted with ice under
    the leading edge slats.</para>
  </sectionLevel1>
  <sectionLevel1>
    <title>Aircraft upgrades</title>
    <para>LE OB slat GRAs will progressively be upgraded with a lockout actuator
    during scheduled maintenance.</para>
  </sectionLevel1>
  <sectionLevel1>
    <title>Operations</title>
    <para>Aircraft fitted with the new LEOLA’s will have the following NTC in the
    eLog:</para>
    <mediaObject>
      <image fileref="/graphics/00/00/00/1D/G0000001D4F/MAIN.png"/>
    </mediaObject>
  </sectionLevel1>
  <signatureBlock>
    <SME>
      <signedBy>Philip Kirk</signedBy>
      <title>Boeing Tech Pilot</title>
    </SME>
    <checked>
      <signedBy>Michael Billett</signedBy>
      <title>Senior Fleet Manager B787/B777</title>
    </checked>
    <operationalReview>
      <signedBy>Andrew Hanley</signedBy>
      <title>Senior Manager Aircraft Operations</title>
    </operationalReview>
    <approved>
      <signedBy>Hugh Pearce</signedBy>
      <title>Head of Operations</title>
    </approved>
  </signatureBlock>
</supplement>
`;

/* http://localhost:3000/api/fs/graphics/00/00/00/1D/G0000001D4F/MAIN.png */

const TEMPLATE1 =
`<?xml version="1.0" encoding="utf-8"?>
<supplement>
  <header>
    <model></model>
    <applicableTo></applicableTo>
    <number></number>
    <cancelling>N/A</cancelling>
    <effectiveDate></effectiveDate>
  </header>
  <title></title>
  <sectionLevel1>
    <title></title>
    <para></para>
  </sectionLevel1>
  
  <signatureBlock>
    <SME>
      <signedBy></signedBy>
      <title></title>
    </SME>
    <checked>
      <signedBy></signedBy>
      <title></title>
    </checked>
    <operationalReview>
      <signedBy></signedBy>
      <title></title>
    </operationalReview>
    <approved>
      <signedBy></signedBy>
      <title></title>
    </approved>
  </signatureBlock>
</supplement>
`;

function MediaFileChooser2(props) {
  const {
    open,
    onCancel,
    onSave,
    title='Choose Graphics',
    node,
    ...other
  } = props;

  const [sizes, setSizes] = useState([100, '25%', 'auto']);
  // const [url, setUrl] = useState('');
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [filteredImages, setFilteredImages] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [categSelection, setCategSelection] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedGlobalIndex, setSelectedGlobalIndex] = useState(-1);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState('');
  const [selectedImageLabel, setSelectedImageLabel] = useState('');
  const theme = useTheme();

  useEffect( () => {
    if ( open ) {
      netGet('/api/catalog/categ')
        .then( response => response.json() )
        .then( categs => {
          if ( Array.isArray(categs) ) {
            setCategories(categs);
            // console.log('Media categoeries: ' + JSON.stringify(categs));
          }
        }).catch( error => console.log('Failed to retrieve categories: ' + error));
      const cs = [...categSelection];
      const cats = cs.map(id => {
        const i = id.indexOf('-');
        if ( i >= 0 && i < id.length - 1) {
          const c = id.substring(i+1);
          // console.log('cat=' + c);
          return c;
        }
        return id;
      }).reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
      // const cat = cs.map(i => categories[i]).reduce((a, b) => a.length > 0 ? a + ',' + b.name : b.name, '');
      setSelectedIndex(-1);
      setSelectedImage(null);
      setSelectedImageLabel('');
      netGet('/api/catalog/image'  + (cs.length > 0 ? '?cat=' + encodeURIComponent(cats) : '') )
        .then(response => response.json())
        .then(data => {
          if (Array.isArray(data)) {
            setImages(data);
            const simage = loadNode();
            if ( simage[0] && simage[0] !== '') {
              let imageIndex = data.findIndex( img => img.name === simage[0]) ;
              if ( imageIndex >= 0 ) {
                // setImages(data);
                const image = data[imageIndex];
                setSelectedImage(image);
                setSelectedImageLabel(image.label);
                setSelectedIndex(imageIndex);
              } else {
                netGet('/api/catalog/image?name=' + encodeURIComponent(simage[0]))
                  .then(response => response.json())
                  .then(data2 => {
                    if ( Array.isArray(data2) ) {
                      // const images = [...data, ...data2];
                      // setImages(images);
                      imageIndex = data2.findIndex(img => img.name === simage[0]);
                      if (imageIndex >= 0) {
                        // console.log('images length=' + images.length + ' : ' + imageIndex);
                        const image = data2[imageIndex];
                        setSelectedImage(image);
                        setSelectedImageLabel(image.label);
                        // setSelectedIndex(imageIndex);
                      }
                    }
                  }).catch(error => console.log('Failed to retrieve image info: ' + error));
              }
            } else {
              setSelectedImage(null);
              setSelectedImageName('');
              setSelectedImageLabel('');
            }
            loadFilteredImages(searchTerm, data);
          }
        }).catch(error => console.log('Failed to retrieve image info: ' + error));
      
      // setCategSelection([]);
    }

  },[open,node]);

  /*
  useEffect( () => {
    if ( Array.isArray(node) ) {
      // console.log('Selected node: ' + JSON.stringify(node));
      const i = node.findIndex( t => t === 'fileref');
      if ( i >= 0 && i<node.length - 1) {
        const fr = node[i+1];
        if ( fr ) {
          const fre = fr.match(/\/(.*?)\/MAIN/);
          if ( Array.isArray(fre) && fre.length > 0 ) {
            let iname = fre[1];
            const j = iname.lastIndexOf('/');
            if ( j >= 0 && j < iname.length-1 ) {
              iname = iname.substring(j+1);
            }
            console.log('Selected image: ' + iname);
            setSelectedImageName(iname);

          }
        }
      }
    }

  },[node]);
  */

  const loadNode = () => {
    if ( Array.isArray(node) ) {
      // console.log('Selected node: ' + JSON.stringify(node));
      const i = node.findIndex( t => t === 'fileref');
      if ( i >= 0 && i<node.length - 1) {
        const fr = node[i+1];
        if ( fr ) {
          const fre = fr.match(/\/(.*?)\/MAIN/);
          if ( Array.isArray(fre) && fre.length > 0 ) {
            let iname = fre[1];
            const j = iname.lastIndexOf('/');
            if ( j >= 0 && j < iname.length-1 ) {
              iname = iname.substring(j+1);
            }
            // console.log('Selected image: ' + iname);
            setSelectedImageName(iname);
            return [iname, null];
          }
        }
      }
    }
    return [null, null];
  };

  const loadFilteredImages = (term, timages) => {
    const lterm = typeof term === 'string' ? term.toLowerCase().trim() : '';
    let fimages = [...timages];
    // console.log('lterm: ' + lterm + ' : ' + fimages.length);
    if ( lterm && lterm !== '') {
      fimages = timages.filter( img => {
        const lname = typeof img.name === 'string' ? img.name.toLowerCase() : '';
        const llabel = typeof img.label === 'string' ? img.label.toLowerCase() : '';
        return lname.includes(lterm) || llabel.includes(lterm);
      });
    }
    setFilteredImages(fimages);
  };

  const debouncedSearchTermChangeHandler = React.useCallback(
        debounce((value, timages) => {
            // Perform your action here with the debounced value
            // console.log('Debounced value:', value);
            loadFilteredImages(value, timages);
            setSearchTerm(value);
        }, 1500), // Debounce delay in milliseconds
        []
    );

  const searchTermChange = (event) => {
    // setSearchTerm(event.target.value);
    debouncedSearchTermChangeHandler(event.target.value, images);
  }

  const onClose = () => {
    onCancel();
  };

  const onCancelClick = () => {
    if ( typeof onCancel === 'function') {
      onCancel();
    }
  };

  const onOKClick = () => {
    if ( typeof onSave === 'function') {
      // onSave(url);
      console.log('selectedImage: ' + JSON.stringify(selectedImage));
      const ext = getImageExtension(selectedImage);
      console.log('image extension = ' + ext);
      const url = selectedImage ? selectedImage.path + '/MAIN' + ext : null;
      console.log('Image URL = ' + url);
      onSave(url, selectedImage);
    }
  };

  const categItemsChange = (event, itemIds) => {
    if ( Array.isArray(itemIds) ) {
      setCategSelection(itemIds);
      setSelectedImage(null);
      setSelectedIndex(-1);
      const cats = itemIds.map(id => {
        const i = id.indexOf('-');
        if ( i >= 0 && i < id.length - 1) {
          const c = id.substring(i+1);
          // console.log('cat=' + c);
          return c;
        }
        return id;
      }).reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
      // console.log('itemIds=' + JSON.stringify(itemIds) + ', cat=' + cats);
      netGet('/api/catalog/image' + (itemIds.length > 0 ? '?cat=' + encodeURIComponent(cats) : ''))
        .then(response => response.json())
        .then(data => {
          if (Array.isArray(data)) {
            setImages(data);
            if (selectedImageName && selectedImageName !== '') {
              const imageIndex = data.findIndex(img => img.name === selectedImageName);
              if (imageIndex >= 0) {
                // setImages(data);
                const image = data[imageIndex];
                setSelectedImage(image);
                setSelectedImageLabel(image.label);
                setSelectedIndex(imageIndex);
              }
            }
            loadFilteredImages(searchTerm, data);
          }
        }).catch(error => console.log('Failed to retrieve image info: ' + error));
    }
  };

  const handleCategClick = (categ, index) => {
    const cs = [...categSelection];
    if ( cs.includes(index) ) {
      const j = cs.findIndex( item => item === index);
      if ( j >= 0 ) {
        cs.splice(j, 1);
      }
    } else {
      cs.push(index);
    }
    setCategSelection(cs);
    setSelectedImage(null);
    setSelectedIndex(-1);
    const cat = cs.map(i => categories[i]).reduce((a, b) => a.length > 0 ? a + ',' + b.name : b.name, '');
    netGet('/api/catalog/image' + (cs.length > 0 ? '?cat=' + encodeURIComponent(cat) : ''))
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          setImages(data);
          if (selectedImageName && selectedImageName !== '') {
            const imageIndex = data.findIndex(img => img.name === selectedImageName);
            if (imageIndex >= 0) {
              // setImages(data);
              const image = data[imageIndex];
              setSelectedImage(image);
              setSelectedImageLabel(image.label);
              setSelectedIndex(imageIndex);
            }
          }
        }
      }).catch(error => console.log('Failed to retrieve image info: ' + error));
  };

  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setSelectedIndex(index);
    setSelectedImageName(image.name);
    setSelectedImageLabel(image.label);
    // console.log('Selected Image: ' + JSON.stringify(image));
  };

  const getImageExtension = (image) => {
    const t = image.type;
    if ( t.includes('png') ) {
      return '.png';
    }
    if ( t.includes('jpeg') ) {
      return '.jpg';
    }
    if ( t.includes('pdf')) {
      return '.pdf';
    }
    if ( t.includes('gif') ) {
      return '.gif';
    }
    if ( t.includes('svg') ) {
      return '.svg';
    }
    if ( t.includes('opus') ) {
      return '.opus';
    }
    if ( t.includes('video') && t.includes('webm')) {
      return '.webm';
    }
    if ( t.includes('audio') && t.includes('webm')) {
      return '.weba';
    }
    if ( t.includes('audio') && t.includes('mpeg')) {
      return '.mp3';
    }
    if ( t.includes('audio') && t.includes('mp4')) {
      return '.m4a';
    }
    if ( t.includes('wav') ) {
      return '.wav';
    }
    if ( t.includes('aac')) {
      return '.aac';
    }
    if ( t.includes('video') && t.includes('mp4')) {
      return '.mp4';
    }
    if ( t.includes('quicktime') ) {
      return '.mov';
    }
    if ( t.includes('x-msvideo')) {
      return '.avi';
    }
    if ( t.includes('video') && t.includes('mpeg')) {
      return '.mpeg'; // or '.mpg'
    }
    if ( t.includes('x-ms-wmv')) {
      return '.wmv';
    }
    if ( t.includes('matroska')) {
      return '.mkv';
    }
    console.log('No extension for ' + t);
    return '';
  }

  const getImageUrl = (image) => {
    // thumbnail is always PNG
    const url = new URL('/api/fs' + image.path + '/THUMB.png', window.location.href);
    return url.toString();
  }

  const itemTemplate = (item, layout, index) => {
    const selected = item.name === selectedImageName;
    return (
      <Tooltip title={
        <Box>
          <Typography sx={{ fontWeight: 'bold' }}>{item.name}</Typography>
          <Typography>{item.label}</Typography>
        </Box>
      }>
        <Box sx={{ width: '104px', padding: 0, margin: 0 }}>
          <IconButton onClick={() => handleImageClick(item, index)}
            sx={{
              border: selected ? '3px solid red' : '3px solid transparent', borderRadius: 0,
              backgroundColor: selected ? 'gray' : 'white',
              padding: 0,
              margin: 0,
            }} >
            <img
              style={{ height: '92px', width: '92px', maxHeight: '92px', maxWidth: '92px', opacity: selected ? 0.6 : 1 }}
              src={getImageUrl(item)}
              alt={item.label}
              loading="lazy"
            />
          </IconButton>
          <Typography sx={{ fontSize: '8pt', overflow: 'clip', padding: '4px', textWrap: 'nowrap', textOverflow: 'ellipsis' }}>{item.label}</Typography>
        </Box>
      </Tooltip>
    );
  };

  const listTemplate = (items, layout) => {
    return <Box sx={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', 
      rowGap: '15px', columnGap: '5px', height: '610px', alignContent: 'flex-start'}}>{items.map((item, index) => itemTemplate(item, layout, index))}</Box>;
  };

  /*
    <ImageList sx={{ width: 500, height: 490, padding: 3, overflow: 'visible' }} cols={7} gap={10}>
                {Array.isArray(images) && images.filter( (item,index) => index < 128).map((item,index) => (
                  <Tooltip title={
                    <Box>
                      <Typography sx={{fontWeight: 'bold'}}>{item.name}</Typography>
                      <Typography>{item.label}</Typography>
                    </Box>
                  }>
                  <ImageListItem key={item.name} sx={{width: '92px', height: '104px', maxHeight: '130px'}} 
                    >
                      <IconButton onClick={() => handleImageClick(item, index)} 
                        sx={{border: selectedIndex === index ? '3px solid red' : 'none', borderRadius: 0}} >
                    <img
                      style={{height: '92px', width: '92px', maxHeight: '92px', opacity: selectedIndex === index ? 0.6 : 1}}
                      src={getImageUrl(item)}
                      alt={item.label}
                      loading="lazy"
                    />
                    </IconButton>
                    <ImageListItemBar
                      subtitle={item.label}
                      position="below"
                      sx={{fontSize: '8pt', paddingTop: '2px !important', paddingBottom: '2px'}}
                    />
                  </ImageListItem>
                  </Tooltip>
                ))}
              </ImageList>

              , display: 'grid', gridTemplateRows: '2em 1fr' 

<List sx={{padding: 0}} >
                  {Array.isArray(categories) && categories.map((categ, index) =>
                    <ListItem key={`cat-categ-${index}`} disablePadding disableGutters
                      >
                      <ListItemButton onClick={() => handleCategClick(categ, index)} dense disableGutters
                        selected={categSelection.includes(index)} >
                        <ListItemText primary={categ.name} sx={{margin: 0, whiteSpace: 'nowrap'}}/>
                      </ListItemButton>

                    </ListItem>
                  )}
                </List>

                sx={{ maxWidth: '500px' }}
                slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }
                    }}
<Box sx={{width: '100%', height: '3em'}} >
                <TextField
                    
                    onChange={e => setSearchTerm(e.target.value)}
                    id="xxe-search"
                    size="small"
                    
                    
                    
                />
              </Box>
  */

  return (
    <Dialog
      maxWidth={'1200px'}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            minWidth: 1000,
            minHeight: 860,
            maxHeight: 1200
          }
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
      <DialogContent >
        
        <Box sx={{width: '100%', height: '100%', position: 'relative'}}>
          <SplitPane
            style={{minHeight: '3.3em'}}
            split="vertical"
            sizes={sizes}
          >
            <Pane minSize={40} maxSize='60%'>
              <Box sx={{ paddingLeft: 0, paddingTop: 1 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>Category</Typography>
                </Box>
            </Pane>
            <Box sx={{width: '100%', textAlign: 'center'}} >
                <TextField
                    defaultValue={searchTerm}
                    onChange={searchTermChange}
                    id="xxe-search"
                    size="small"
                    type="search"
                    fullWidth
                    sx={{ maxWidth: '500px' }}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }
                    }}
                />
            </Box>
          </SplitPane>
          <SplitPane
            style={{minHeight: '680px', height: '100%'}}
            split='vertical'
            sizes={sizes}
            onChange={setSizes}
          >
            <Pane minSize={40} maxSize='60%'>
              <Box sx={{ height: '100%', position: 'relative', overflow: 'auto' }}>
                
                <SimpleTreeView multiSelect selectedItems={categSelection} onSelectedItemsChange={categItemsChange}>
                  {Array.isArray(categories) && categories.map((categ, index) =>
                    <TreeItem itemId={`C${index}-${categ.name}`} label={categ.name} />
                  )}
                </SimpleTreeView>
              </Box>
            </Pane>
            <Box sx={{
              height: '100%', position: 'relative', overflow: 'auto', paddingLeft: 1,
              borderLeftColor: theme.palette.divider, borderLeftStyle: 'solid', borderLeftWidth: '2px'
            }} >
              
              <DataView value={filteredImages} listTemplate={listTemplate} layout="grid" paginator rows={24} />
            </Box>
          </SplitPane>
        </Box>
      </DialogContent>
      <DialogActions sx={{ m: 1, display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{display: 'flex'}}>
          <Box>
            <Box sx={{ paddingLeft: 2, width: '8em', fontWeight: 'bold' }}>Selected:</Box>
            <Box sx={{ width: '8em' }}>{'\xa0'}</Box>
          </Box>
            <Box>
              <Box>{selectedImage && selectedImage.name ? selectedImage.name : selectedImageName}</Box>
              <Box>{selectedImage && selectedImage.label ? selectedImage.label : selectedImageLabel}</Box>
            </Box>
            
        </Box>
        <Box sx={{ display: 'inline' }}>
          <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} color="success">OK</Button>
          <Button variant="outlined" onClick={onCancelClick} sx={{ marginLeft: 2, minWidth: '7em' }}>Cancel</Button>
        </Box>
      </DialogActions>
    </Dialog>

);


}

function CheckinDialog(props) {
    const {
        title = 'Checkin Document Unit',
        open,
        node,
        onSave,
        onCancel,
        ...other
    } = props;
    const [message, setMessage] = React.useState('');


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave(message, node);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const messageChanged = (event) => {
        setMessage(event.target.value);
    }


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxWidth: 600,
                        maxHeight: 320,
                        minHeight: 320,
                    }                   
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{ paddingTop: '2ex' }}>
                    <TextField label="Checkin message" value={message} onChange={messageChanged} size="small" fullWidth autoFocus={true}
                        multiline rows={4} />
                </Box>

            </DialogContent>
            <DialogActions sx={{padding: 4, paddingTop: 0}}>
                <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} >Checkin</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', ml: 4 }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function RightEditorPanel(props) {
  const {
    editor,   // from editor.current
    panelName, // rightDrawerPanel
    propertyPanel,
    selectedId,
    selectedNode,
    propertyNode,
    setPropertyNode,
    enableEff,
    onClose,
    effTree,
    effMap,
    effValue,
    setEffValue,
    setSaveNeeded,
    docEff,
    setDocEff,
    docAnnot,
    setDocAnnot,
    selectedEffItems,
    setSelectedEffItems,
    selectedEff,
    setSelectedEff,
    du,
    ...other
  } = props;

  // const [selectedEffItems, setSelectedEffItems] = useState([]);
  const [expandedEffItems, setExpandedEffItems] = useState([]);
  const [colorDialogOpen, setColorDialogOpen] = useState(false);
  const [colorDialogProp, setColorDialogProp] = useState('color'); // name of color property to edit
  const [colorDialogValue, setColorDialogValue] = useState('#000000');
  // const [selectedEff, setSelectedEff] = useState(null); // selected effectivity as reported by backend
  const [prevEff, setPrevEff] = useState(null); // previous selected effectivity 


  useEffect(() => {
    // console.log('effTree: ' + JSON.stringify(effTree));
    const exp = [];
    if (Array.isArray(effTree)) {
      scanTree(effTree, exp);
    }
    setExpandedEffItems(exp);
  },[effTree]);

  const scanTree = (tree, exp) => {
    if (Array.isArray(tree)) {
      tree.forEach(eff => {
        if (Array.isArray(eff.children) && eff.children.length > 0) {
          exp.push(eff.key);
          scanTree(eff.children, exp);
        }
      });
    }
  }

  const handleDrawerClose = () => {
    if ( typeof onClose === 'function') {
      onClose();
    }
  };

  const handleEffUndo = () => {

  };

  const handleEffClear = () => {
    setSelectedEffItems([]);
    let eff = selectedEff ? { ...selectedEff} : { id: '__UNKNOWN__', effectivity: [] };
    eff.effectivity = [];
    const param = JSON.stringify(eff);
    const st = editor['uxState'];
    editor.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setEffectivity', param)
      .then ( result => {
        if (result?.status === XXE.COMMAND_RESULT_DONE) {
          const sids = [];
          if ( result?.value ) {
            try {
              const effs = JSON.parse(result.value);
              // console.log('setEff value=' + JSON.stringify(effs));
              if ( Array.isArray(effs) ) {
                const deff = { ...docEff };
                effs.forEach((seff,index) => {
                  if ( index === 0 ) {
                    eff = seff;
                  }
                  if ( seff.key ) {
                    sids.push(seff.key);
                  } else if ( Array.isArray(seff.effectivity) ) {
                    seff.effectivity.forEach( einfo => {
                      if ( einfo.key && !sids.includes(einfo.key) ) {
                        sids.push(einfo.key);
                      }
                    });
                  }
                  if (seff.id) {
                    // console.log('storing eff id=' + seff.id);
                    deff[seff.id] = seff;                    
                    st.docEff[seff.id] = seff;
                    st.selectedId = seff.id;
                  }
                });
                if ( typeof setDocEff === 'function') {
                  setDocEff(deff);
                }
              }
            } catch (error) {
              console.log('Error paring setEff value: ' + error);
            }
          }
          if ( typeof setSaveNeeded === 'function') {
            setSaveNeeded(true);
          }
          setSelectedEffItems(sids);
          // console.log('Selected ids: ' + JSON.stringify(sids));
          st.selectedEff = eff;
          setSelectedEff(eff);
          /*
          eff.effectivity.sort( (a,b) => a.valueSortKey.localeCompare(b.valueSortKey));
          const v = eff.effectivity.reduce((sum, current) => sum !== '' ? sum + ',' + current.label : current.label, '');
          */
          if ( typeof setEffValue === 'function') {
            // setEffValue(v);
            setEffValue('');
          }
        } else {
          console.log('No result from setEffectivity command!');
        }
      });
  };

  const handleSelectedItemsChange = (event, sids) => {
    // setSelectedEffItems(ids);
    // console.log('selItemsChange: ' + JSON.stringify(sids));
    const ids = [];
    let eff = selectedEff ? { ...selectedEff} : { id: '__UNKNOWN__', effectivity: [] };
    eff.effectivity = [];
    sids.forEach( key => {
      const ei = effMap[key];
      if ( ei && ei.select) {
        ids.push(key);
        eff.effectivity.push(ei);
      }
    });
    setSelectedEffItems(ids);
    // console.log('effMap: ' + JSON.stringify(effMap));
    // console.log('EFF to SET: ' + JSON.stringify(eff));
    // console.log('EFF to SET ' + eff.id);
    const param = JSON.stringify(eff);
    const st = editor['uxState'];
    editor.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setEffectivity', param)
      .then ( result => {
        if (result?.status === XXE.COMMAND_RESULT_DONE) {
          const sids = [];
          if ( result?.value ) {
            try {
              const effs = JSON.parse(result.value);
              // console.log('setEff value=' + JSON.stringify(effs));
              if ( Array.isArray(effs) ) {
                const deff = { ...docEff };
                effs.forEach((seff,index) => {
                  if ( index === 0 ) {
                    eff = seff;
                  }
                  if ( seff.key ) {
                    sids.push(seff.key);
                  } else if ( Array.isArray(seff.effectivity) ) {
                    seff.effectivity.forEach( einfo => {
                      if ( einfo.key && !sids.includes(einfo.key) ) {
                        sids.push(einfo.key);
                      }
                    });
                  }
                  if (seff.id) {
                    // console.log('storing eff id=' + seff.id);
                    deff[seff.id] = seff;                    
                    st.docEff[seff.id] = seff;
                    st.selectedId = seff.id;
                  }
                });
                if ( typeof setDocEff === 'function') {
                  setDocEff(deff);
                }
              }
            } catch (error) {
              console.log('Error paring setEff value: ' + error);
            }
          }
          if ( typeof setSaveNeeded === 'function') {
            setSaveNeeded(true);
          }
          setSelectedEffItems(sids);
          // console.log('Selected ids: ' + JSON.stringify(sids));
          st.selectedEff = eff;
          setSelectedEff(eff);
          eff.effectivity.sort( (a,b) => a.valueSortKey.localeCompare(b.valueSortKey));
          const v = eff.effectivity.reduce((sum, current) => sum !== '' ? sum + ',' + current.label : current.label, '');
          if ( typeof setEffValue === 'function') {
            setEffValue(v);
          }
        } else {
          console.log('No result from setEffectivity command!');
        }
      });
  };

  const renderTreeItem = (item) => {
    /* .filter(item => du.ancestors ? du.ancestors.includes(item.data?.documentId) : true) */
    // console.log('MATCH: ' + JSON.stringify(du.ancestors) + ' : ' + item.data?.documentId);
    return (
      <TreeItem sx={{ padding: '0.5ex' }}
        itemId={item.key}
        label={item.label}
        disabled={false}
        slots={{
          icon: Brightness1Icon
        }}
        slotProps={{
          icon: {
            sx: { color: item.data?.colorValue ? item.data?.colorValue : '#000', paddingRight: '0.5ex' }
          }
        }}

      >
       {Array.isArray(item.children) && item.children.filter(item => du.ancestors ? du.ancestors.includes(item.data?.documentId) : true).map( child => renderTreeItem(child))}
      </TreeItem>
    );
  };

  const handleColorSave = (value) => {
    setColorDialogOpen(false);
    // console.log('color: ' + JSON.stringify(value));
    const einfo = {
      name: propertyNode?.tag,
      attributes: {...propertyNode?.attributes},
      matchId: true,
      skipRebuild: false,
    };
    if ( value ) {
      const style = parseStyleProperty(einfo.attributes['style']);
      const c = einfo.attributes['color'];
      if ( !style['color'] && c ) {
        style['color'] = c;
      }
      style[colorDialogProp] = value;
      const fstyle = formatStyleProperty(style);
      einfo.attributes['style'] = fstyle;
      einfo.attributes['color'] = undefined; // remove legacy color property
      const pnode = {...propertyNode};
      pnode.attributes['style'] = fstyle;
      pnode.attributes['color'] = undefined;
      if ( typeof setPropertyNode === 'function') {
        setPropertyNode(pnode);
      }
    }
    // console.log('setElement: ' + JSON.stringify(einfo));
    editor?.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setElement', JSON.stringify(einfo))
      .then( result => {
        if ( result?.status !== XXE.COMMAND_RESULT_DONE ) {
          console.log('Error setting properties');
        }
      });
  };

  const handleCrmSave = (propNode, options) => {
    handlePropertySave(propNode, options);
  }

  const handlePropertySave = (propNode, options) => {
    const einfo = {
      name: propNode?.tag,
      attributes: {...propNode?.attributes},
      matchId: typeof options?.matchId === 'boolean' ? options.matchId : true,
      skipRebuild: typeof options?.skipRebuild === 'boolean' ? options.skipRebuild : false,
    };
    if (typeof setPropertyNode === 'function') {
      setPropertyNode(propNode);
    }
    editor?.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setElement', JSON.stringify(einfo))
      .then( result => {
        if ( result?.status !== XXE.COMMAND_RESULT_DONE ) {
          console.log('Error setting properties');
        }
      });
  };

  const handleTableEntrySave = (propNode, options) => {
    if (options?.op === 'SPAN') {
      const einfo = {
        name: propNode?.tag,
        attributes: { ...propNode?.attributes },
        matchId: typeof options?.matchId === 'boolean' ? options.matchId : true,
        skipRebuild: typeof options?.skipRebuild === 'boolean' ? options.skipRebuild : false,
        properties: {
          spanType: options.type ? options.type : 'NONE',
          value: options.value,
        }
      };
      // console.log('Executing COLSPAN: ' + JSON.stringify(einfo));
      editor?.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setEntrySpan', JSON.stringify(einfo))
        .then(result => {
          if (result?.status !== XXE.COMMAND_RESULT_DONE) {
            console.log('Error setting entry span');
          }
        });
    } else if (options?.op === 'CMD' && options.cmd ) {
        editor?.documentView.executeCommand(XXE.EXECUTE_NORMAL, options.cmd, typeof options?.param === 'string' ? options.param : '')
        .then(result => {
          if (result?.status !== XXE.COMMAND_RESULT_DONE) {
            console.log('Error running command ' + options.cmd);
          }
        });
    } else {
      handlePropertySave(propNode, options);
    }
  };


  const handleColorClick = (node, prop, color) => {
    setColorDialogOpen(true);
    const v = getStyleProperty(node?.attributes?.style, prop, color);
    const c = v ? v : (prop === 'color' ? '#000' : '#FFF');
    // setColorNode(node);
    setColorDialogValue(c);
    setColorDialogProp(prop);
  };

  return (
    <Box sx={{ position: 'relative', overflowY: 'auto', overflowX: 'hidden',  flexGrow: '1', backgroundColor: 'white', zIndex: '10',  borderLeft: '1px solid #F0F0F0'}}>
      {/* Effectivity panel */}
      <Box sx={{ position: 'absolute', visibility: panelName === 'EFF' ? 'visible' : 'hidden' }} >
        <Box sx={{
          display: 'flex', justifyContent: 'flex-start',
          padding: 1, paddingLeft: 0, paddingRight: 2, paddingBottom: 0,
          alignItems: 'center',
          borderTopWidth: 'var(--xui-border-width)', borderTopColor: 'var(--xui-border-color)', borderTopStyle: 'solid',
        }}>
          <Tooltip title="Close">
            <IconButton onClick={handleDrawerClose} size="small" sx={{mr: 1, ml: 1}}>
              <CloseIcon fontSize="inherit"/>
            </IconButton>
          </Tooltip>
          <Typography sx={{ fontWeight: 'bold' }}>Effectivity</Typography>
        </Box>

        <Box sx={{ marginTop: '2px', padding: 1, borderTopWidth: 'var(--xui-border-width)', borderTopColor: 'var(--xui-border-color)', borderTopStyle: 'solid', borderTopLeftRadius: '3px' }}>
          <Tooltip title={effValue}>
            <TextField
              fullWidth
              size="small"
              value={effValue}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start" sx={{ paddingLeft: 0, marginLeft: 0 }}>
                      <Tooltip title="Reset">
                        <IconButton onClick={handleEffUndo} sx={{ padding: 0 }}><UndoIcon /></IconButton>
                      </Tooltip>
                      <Tooltip title="Clear">
                        <IconButton onClick={handleEffClear} sx={{ padding: 0 }}><ClearIcon /></IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                  readOnly: true,
                },
              }}
            />
          </Tooltip>
          <SimpleTreeView multiSelect selectedItems={selectedEffItems} disabled={!enableEff}
            disableSelection={!enableEff} expansionTrigger="iconContainer" expandedItems={expandedEffItems}
            onSelectedItemsChange={handleSelectedItemsChange} sx={{ marginTop: 1 }}>
            {effTree.filter(item => du.ancestors ? du.ancestors.includes(item.data?.documentId) : true).map(item => renderTreeItem(item))}
          </SimpleTreeView>
        </Box>
      </Box>
      {panelName === 'ANNOT' && 
        <AnnotationsPanel visible={panelName === 'ANNOT'} document={du?.document} selectedNode={selectedNode} onClose={handleDrawerClose} 
            selectedAnnot={docAnnot} setDocAnnot={setDocAnnot} />
      }
      {/* Property panel */}
      <Box sx={{ position: 'absolute', display: panelName === 'PROP' ? 'block' : 'none', width: '100%' }}>
        <Box sx={{
          display: 'flex', justifyContent: 'flex-start', 
          padding: 1, paddingLeft: 0, paddingRight: 2, paddingBottom: 0,
          alignItems: 'center',
          borderTopWidth: 'var(--xui-border-width)', borderTopColor: 'var(--xui-border-color)', borderTopStyle: 'solid',
        }}>
          <Tooltip title="Close">
            <IconButton onClick={handleDrawerClose} size="small" sx={{mr: 1, ml: 1}}>
              <CloseIcon fontSize="inherit"/>
            </IconButton>
          </Tooltip>
          <Typography sx={{ fontWeight: 'bold' }}>Properties</Typography>
        </Box>
        <Box sx={{
          marginTop: '2px', padding: 1, position: 'relative',
          borderTopWidth: 'var(--xui-border-width)', borderTopColor: 'var(--xui-border-color)', borderTopStyle: 'solid', borderTopLeftRadius: '3px'
        }}>
          <Typography sx={{
            color: '#D0D0D0', fontSize: '95%', position: 'absolute', width: '100%',
            marginTop: 3, textAlign: 'center', visibility: propertyPanel === 'NONE' ? 'visible' : 'hidden'
          }}>No properties available.</Typography>
          <Box sx={{
            marginTop: 2, visibility: propertyPanel === 'EMPHASIS' ? 'visible' : 'hidden',
            position: 'absolute', width: '100%',
            fontSize: '92%'
          }}>
            <Box sx={{ display: 'flex', marginRight: 1, alignItems: 'baseline', fontSize: 'inherit' }}>
              <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>Element:</Typography>
              <TextField defaultValue={propertyNode?.tag} variant="standard" slotProps={{
                input: {
                  readOnly: true,
                  sx: { fontSize: 'inherit', width: '180px' }
                },
              }} />
            </Box>
            {/* 
            <Box sx={{ display: 'flex', marginTop: 2, alignItems: 'baseline', fontSize: 'inherit' }}>
              <Typography sx={{ fontWeight: 'bold', width: '70px', fontSize: 'inherit' }}>ID:</Typography>
              <TextField readOnly defaultValue={propertyNode?.attributes?.id} variant="standard" slotProps={{
                input: {
                  readOnly: true,
                  sx: { fontSize: '90%', width: '180px' }
                },
              }} />
            </Box>
            */}
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 3, alignItems: 'center', fontSize: 'inherit' }}>
              <Typography sx={{ fontWeight: 'bold', width: '70px', marginRight: 0, fontSize: 'inherit' }}>Color:</Typography>
              <TextField value={convertColor(getStyleProperty(propertyNode?.attributes?.style, 'color', propertyNode?.attributes?.color))}
                variant="standard"
                slotProps={{
                  input: {
                    readOnly: true,
                    sx: { fontSize: 'inherit', width: '180px' },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton onClick={() => handleColorClick(propertyNode, 'color', propertyNode?.attributes?.color)} sx={{ fontSize: '16px' }}>
                          <Brightness1Icon fontSize="small" sx={{
                            color: getStyleProperty(propertyNode?.attributes?.style, 'color', propertyNode?.attributes?.color),
                            fontSize: 'inherit', border: '1px gray solid', borderRadius: '10px'
                          }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }} />
            </Box>
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 2, alignItems: 'center', fontSize: 'inherit', position: 'relative', top: '0.5ex' }}>
              <Typography sx={{ fontWeight: 'bold', marginRight: 0, fontSize: 'inherit' }}>Background</Typography>
            </Box>
            <Box sx={{ display: 'flex', marginRight: 1, marginTop: 0, alignItems: 'center', fontSize: 'inherit' }}>
              <Typography sx={{ fontWeight: 'bold', width: '70px', marginRight: 0, fontSize: 'inherit' }}>Color:</Typography>
              <TextField value={convertColor(getStyleProperty(propertyNode?.attributes?.style, 'background-color'))}
                variant="standard"
                slotProps={{
                  input: {
                    readOnly: true,
                    sx: { fontSize: 'inherit', width: '180px' },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton onClick={() => handleColorClick(propertyNode, 'background-color')} sx={{ fontSize: '16px' }}>
                          <Brightness1Icon fontSize="small" sx={{
                            color: getStyleProperty(propertyNode?.attributes?.style, 'background-color'),
                            fontSize: 'inherit', border: '1px gray solid', borderRadius: '10px'
                          }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }} />
            </Box>
          </Box>
          {propertyPanel === 'CHALLENGE_RESPONSE' && <ChallengeResponsePanel visible={propertyPanel === 'CHALLENGE_RESPONSE' ? 'visible' : 'hidden'} propertyNode={propertyNode}
            document={du?.document} onSave={handleCrmSave} />}
          {propertyPanel === 'GOTO_STEP' && <GotoStepPanel visible={propertyPanel === 'GOTO_STEP' ? 'visible' : 'hidden'} propertyNode={propertyNode} editor={editor}
            document={du?.document} onSave={handleCrmSave} />}
          {propertyPanel === 'GOTO_CHECKLIST' && <GotoChecklistPanel visible={propertyPanel === 'GOTO_CHECKLIST' ? 'visible' : 'hidden'} propertyNode={propertyNode} editor={editor}
            document={du?.document} onSave={handleCrmSave} workflowInstance={du?.workflowInstance} />}
          {propertyPanel === 'TABLE_ENTRY' && <TableEntryPanel visible={propertyPanel === 'TABLE_ENTRY' ? 'visible' : 'hidden'} 
            propertyNode={propertyNode} editor={editor} document={du?.document} workflowInstance={du?.workflowInstance} onSave={handleTableEntrySave} />}
        </Box>

      </Box>
      <ColorPickerDialog open={colorDialogOpen} color={colorDialogValue} onCancel={() => setColorDialogOpen(false)} onSave={handleColorSave} disableAlpha={true} />
    </Box>
  );
}

// var mediaChooserOpened = false;
// var mediaChooserUrl = '';
//var mediaChooserImage = null;
// var globalRightDrawerOpen = false;
// var globalRightDrawerPanel = 'EFF';
/*
let selectedEff = null;
let effCmdMap = {};
*/

function ReactXMLEditor(props) {
  const {
    name='',
    path,
    eid, // editor id to match to redux messages
    du, // document unit as a DocumentNode object
    readOnly = false,
    showHeader = true,
    showToolbar = true,
    component="xxe-client",
    rightDrawerTop="54px",
    onSaveNeeded,
    onSaved,
    onClosed,
    ...other
  } = props;
  const [mediaChooserDialogOpen, setMediaChooserDialogOpen] = useState(false);
  const [createTableDialogOpen, setCreateTableDialogOpen] = useState(false);
  const [mediaUrl, setMediaUrl] = useState('');
  const [saveNeeded, setSaveNeeded] = useState(false);
  const [opened, setOpened] = useState(false);
  const [editorLabel, setEditorLabel] = useState('');
  const [effList, setEffList] = useState([]);
  const [effTree, setEffTree] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [selectedNode, setSelectedNode] = useState(null); // current nodepath items
  const [selectedElement, setSelectedElement] = useState(null); // current nodepath selected node
  const [effMap, setEffMap] = useState({}); // global effectivity map for this document
  const [docEff, setDocEff] = useState({}); // map of xml id to list of effectivities on each element
  const [docAnnot, setDocAnnot] = useState({}); // map of xml id to list of annotations on each element
  const [annotMap, setAnnotMap] = useState({}); // global annotation map for this document
  const [selectedAnnot, setSelectedAnnot] = useState(null);
  const [selectedEff, setSelectedEff] = useState(null); // selected effectivity as reported by backend
  const [prevEff, setPrevEff] = useState(null); // previous selected effectivity 
  const [selectedEffItems, setSelectedEffItems] = useState([]); // selected items in the tree display
  const [expandedEffItems, setExpandedEffItems] = useState([]);
  const [effValue, setEffValue] = useState('');
  const [effDefaultKey, setEffDefaultKey] = useState(''); // default Effectivity key if any
  const [enableEff, setEnableEff] = useState(false);
  // const [effCmdMap, setEffCmdMap] = useState({});
  const [operator, setOperator] = useState('NZ');
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [rightDrawerWidth, setRightDrawerWidth] = useState('270px');
  const [rightDrawerPanel, setRightDrawerPanel] = useState('EFF'); // EFF, PROP
  const [propertyPanel, setPropertyPanel] = useState('NONE');
  const [propertyNode, setPropertyNode] = useState(null);
  const [colorDialogValue, setColorDialogValue] = useState('#000000');
  const [internalLinkChooserDialogOpen, setInternalLinkChooserDialogOpen] = useState(false);
  const [externalLinkChooserDialogOpen, setExternalLinkChooserDialogOpen] = useState(false);
  const [linkInfo, setLinkInfo] = useState({}); // element info to use in LinkChoosers
  const [externalLinkInfo, setExternalLinkInfo] = useState({});
  const [contentInclusionInfo, setContentInclusionInfo] = useState({}); // element info to use in content inclusion dialog
  const [docId, setDocId] = useState('');
  const [documentProfile, setDocumentProfile] = useState('GEN');
  const [contentInclusionDialogOpen, setContentInclusionDialogOpen] = useState(false);
  const [contentInclusionValue, setContentInclusionValue] = useState('');
  const [contentInclusionParam, setContentInclusionParam] = useState('');
  const [footnoteRefInfo, setFootnoteRefInfo] = useState(null);
  const [footnoteRefChooserDialogOpen, setFootnoteRefChooserDialogOpen] = useState(false);
  const isFormEnabled = useSelector((state) => state.auth.formEnabled);
  const saveAction = useSelector((state) => state.xeditor.saveEvent);
  const closeAction = useSelector((state) => state.xeditor.closeEvent);
  
  const editor = useRef(null);
  const theme = useTheme();

  const CLIENT_VERSION = XMLEditorWrapper.CLIENT_VERSION;

  /* serverurl="ws://localhost:18078/xxe/ws" */

  useEffect(() => {
    netGet('/config/realm')
      .then(response => response.json())
      .then(rinfo => {
        if (rinfo?.realm) {
          setOperator(rinfo.realm);
        }
      }).catch(error => {
        console.log('Error fetching realm name: ' + error);
      });
    const closeUnsub = postal.subscribe(
      'app.xmleditor.close',
      (envelope) => {
        if (envelope.payload.id === eid) {
          if (editor.current) {
            if (editor.current?.documentIsOpened) {
              editor.current.closeDocument(/*discardChanges*/ true).then(() => {
                if (typeof onClosed === 'function') {
                  onClosed(du, {noCloseWindow: true});
                }
              });
              editor?.current?.disconnect();
            }
          }
        }
      }
    );
    return () => {
      closeUnsub();
      closeDocument();
    };
  }, []);

  useEffect( () => {
    setEditorLabel(name);
  }, [name]);

  useEffect( () => {
    if ( typeof onSaveNeeded === 'function') {
      const sn = saveNeeded;
      onSaveNeeded(sn);
    }
  }, [saveNeeded]);

  useEffect( () => {
    if ( saveAction.id === eid) {
      handleSave(saveAction);
    }
  },[saveAction]);

  useEffect( () => {
    if ( editor.current?.uxState ) {
      editor.current.uxState.rightDrawerOpen = rightDrawerOpen;
    }
  }, [rightDrawerOpen]);

  useEffect( () => {
    if ( editor.current?.uxState ) {
      editor.current.uxState.rightDrawerPanel = rightDrawerPanel;
    }
  }, [rightDrawerPanel]);

  useEffect( () => {
    if (closeAction.id === eid) {
      if (editor.current) {
        /*
        editor.current.closeDocument(true).then(() => {
          if (typeof onClosed === 'function') {
            onClosed(du);
            
          }
        });
        editor?.current?.disconnect();
        */
      }
    }
  },[closeAction]);

  useEffect(() => {
    if (path) {
      setOpened(false);
      /*
      const importComponent = async () => {
          const module = await import('/xxe/xxeclient/xxeclient.js');
          //const AnotherComponent = module.default;
          //setImportedComponent(<AnotherComponent />);
        };
      */
      if (editor.current) {
        // console.log('XML autorecover = ' + editor.current.autoRecover);
        editor.current.autoRecover = false;
        editor.current.resourceStorage = new UcpStorage(editor.current);
        editor.current.addEventListener('connected', editorConnected);
        editor.current.addEventListener('saveStateChanged', editorSaveChanged);
        if (editor.current.connected) {
          openDoc(path);
        } else {
          // console.log('adding event listener...'  + name);

          editor.current.connect().catch(error => console.log('error connecting: ' + error));

        }
      } else {
        console.log('XML Editor not yet mounted!!!');
      }
    }
  }, [path]);

  useEffect(() => {
    console.log("DU CHANGE: " + du.entry?.id + ', readOnly = ' + readOnly);
    if (du) {
      // console.log('XML DU: ' + JSON.stringify(du));
      setOpened(false);
      if ( du.name ) {
        setEditorLabel(du.name);
      }
      console.log('DU targetProfile on open: ' + du.targetProfile);
      if ( du.targetProfile ) {
        setDocumentProfile(du.targetProfile);
      } else {
        setDocumentProfile('GEN');
      }
      if (editor.current) {
        // console.log('XML autorecover = ' + editor.current.autoRecover);
        editor.current.autoRecover = false;
        editor.current.resourceStorage = new UcpStorage(editor.current);
        editor.current.addEventListener('connected', editorConnected);
        editor.current.addEventListener('saveStateChanged', editorSaveChanged);
        if (editor.current.connected) {
          // openDocUnit(du);
          
          netGet('/api/doc/schema/config/' + encodeURIComponent(du.document) + '?path=config/sections&a=1')
            .then(result => result.json())
            .then(r => {
                if ( r['config/sections'] ) {
                  console.log('Sections for ' + du.document + ' : ' + JSON.stringify(r['config/sections']));
                  openDocUnit(du, {sections: r['config/sections']});
                  // openDocUnit(du, {});
                } else {
                  console.log('Sections result: ' + JSON.stringify(r) );
                  openDocUnit(du, {});
                }
            }).catch(error => {
              console.log('error retrieving schema sections: ' + error);
              openDocUnit(du, {});
              
            });
          
        } else {
          
          // console.log('adding event listener...'  + name);
          editor.current.connect().catch(error => console.log('error connecting: ' + error));

        }
      } else {
        console.log('XML Editor not yet mounted!!!');
      }
    } else {
      closeDocument();
    }

  }, [du, readOnly]);

  /*
  useEffect( () => {
    console.log('READ ONLY change: ' + readOnly);
  }, [readOnly]);
  */

  /*
  useEffect ( () => {
    console.log('Form Enabled = ' + isFormEnabled);
  },[isFormEnabled]);
  */

  const loadDocumentEffConfig = (doc) => {
    netGet('/api/dlib/config/get/byname/' + encodeURIComponent(doc) + '?categ=DOC')
      .then(resp => resp.json())
      .then(config => {
        if (config) {

          let nodes = config.properties?.eff?.source ? config.properties.eff.source : [];
          if (!Array.isArray(nodes)) {
            nodes = [];
          }
          const elist = [];
          flattenTree(elist, nodes);
          setEffList(elist);

        }
      }).catch(error => {
        // console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
      });
  };


  const editorConnected = (event) => {
    console.log('editor connected!');
    if (!opened) {
      if (du) {
        // openDocUnit(du); 
        netGet('/api/doc/schema/config/' + encodeURIComponent(du.document) + '?path=config/sections&a=1')
            .then(result => result.json())
            .then(r => {
                if ( r['config/sections'] ) {
                  console.log('Sections for ' + du.document + ' : ' + JSON.stringify(r['config/sections']));
                  openDocUnit(du, {sections: r['config/sections']});
                  // openDocUnit(du, {});
                } else {
                  console.log('Sections result: ' + JSON.stringify(r) );
                  openDocUnit(du, {});
                }
            }).catch(error => {
              console.log('error retrieving schema sections: ' + error);
              openDocUnit(du, {});
              
            });
      } else {
        openDoc(path);
      }
    }
  };

  const editorSaveChanged = (event) => {
    setSaveNeeded(event.saveNeeded);
  };

  const flattenTree = (docId, list, tree, treeList, elist, exp, seq) => {
    if (Array.isArray(tree)) {
      tree.forEach(eff => {
        list.push(eff);
        const m = eff.data?.item?.group ? eff.data?.item?.group : eff.data?.item?.stmt;
        if (m) {
          const index = seq[0];
          const sindex = '' + index;
          const item = {
            key: getRandomKey7() + sindex,
            namespace: m.namespace,
            document: docId,
            documentId: eff.data?.doc?.id,
            value: eff.data?.ename,
            label: eff.data?.title ? eff.data.title : eff.data?.ename,
            // select: typeof eff.data?.select === 'boolean' ? eff.data.select : true,
            select: true,
            tail: false,
            valueSortKey: 'S' + decimalToHexString(index, 5),
            colorValue: eff.data?.color,
            equation: eff.data?.item?.group ? m.label : m.equation,
          }
          // console.log('key: ' + item.key + ' > ' + sindex.length + ' > ' + item.key.length);
          elist.push(item);
          const titem = {
            key: item.key,
            data: item,
            label: item.label,
            value: item.value,
            children: [],
          };
          treeList.push(titem);
          seq[0] = index + 1;
          if (Array.isArray(eff.children) && eff.children.length > 0) {
            exp.push(item.key);
            flattenTree(docId, list, eff.children, titem.children, elist, exp, seq);
          }
        }
      });
    }
  };

  const xmlParser = new DOMParser();

  const documentConfigChanged = (event) => {
    console.log("documentConfigChanged: " + JSON.stringify(event.toolSets));
    if ( Array.isArray(event.toolSets) ) {
      /*
      const spec = {
        label: 'Metadata',
        override: true,
        tools: [{ type: 'span', items: [] },
      };
      */
      const spec = {
        label: 'Metadata',
        override: true,
        tools: [],
      };
      //const cmdMap = {};
      const effItem = {
        iconName: 'styles',
        label: "Effectivity",
        tooltip: "Toggle Effectivity panel",
        cmdName: "openRightDrawer()",
        cmdParam: /* JSON.stringify(eff) */ 'EFF',

      };
      // cmdMap[effItem.cmdParam] = /* eff */ 'EFF';
      
      // spec.tools[0]['items'].push(effItem);
      spec.tools.push(effItem);
      

      const propItem = {
        iconName: 'cog',
        label: 'Properties',
        tooltip: "Toggle Properties panel",
        cmdName: 'openRightDrawer()',
        cmdParam: 'PROP',
      };
      // spec.tools[0]['items'].push(propItem);
      spec.tools.push(propItem);
      spec.tools.push({});
      /*
      if (Array.isArray(editor.current.uxToolBar.metaToolSets)) {
        editor.current.uxToolBar.metaToolSets.forEach(tool => {
          if (Array.isArray(tool.tools)) {
            tool.tools.forEach(toolItem => {
              spec.tools.push(toolItem);
            });
          }
        });
      }
      */
      if (Array.isArray(editor.current.uxToolBar.metaToolSets) && editor.current.uxToolBar.metaToolSets.length > 0) {
        editor.current.uxToolBar.metaToolSets.forEach(tool => {
          if (Array.isArray(tool.tools)) {
            tool.tools.forEach((toolItem, j) => {
              // spec.tools.push(toolItem);
              if (j === 0 && Array.isArray(toolItem.items)) {
                const annotItem = {
                  iconData: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJQaW5CbHVlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiDQoJIHk9IjBweCIgdmlld0JveD0iMCAwIDMyIDMyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNWQ1ZDYwIiBkPSJNMCwzMi4ybDIwLjE4LTE2LjU3DQoJCWwtMy42Mi0zLjYyTDAsMzIuMnoiLz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNTg5OWZmIiBkPSJNMTkuNSwyMy45Mkw4LjI4LDEyLjcxDQoJCWwyLjI0LTIuMjRsMS40OSwxLjVsOC4yMi04LjIybC0xLjQ5LTEuNDlsMS41Ny0xLjU3TDIwLjk5LDBMMzIuMiwxMS4yMWwtMi4yNCwyLjI0bC0xLjUtMS41bC0wLjc1LDAuNzVsLTcuNDcsNy40N2wxLjUsMS41DQoJCWwtMC42NSwwLjY1bC0wLjU4LDAuNThMMTkuNSwyMy45MnoiLz4NCjwvZz4NCjwvc3ZnPg0KDQoNCg0K',
                  label: 'Annotations',
                  tooltip: 'Toggle Annotations panel',
                  cmdName: 'openRightDrawer()',
                  cmdParam: 'ANNOT',
                };
                // toolItem.items.push({});
                // toolItem.items.push(annotItem);
                spec.tools.push(annotItem);
                toolItem.items.forEach(item => spec.tools.push(item));
              }
            });
          }
        });
      } else {
        const annotItem = {
          iconData: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJQaW5CbHVlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiDQoJIHk9IjBweCIgdmlld0JveD0iMCAwIDMyIDMyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNWQ1ZDYwIiBkPSJNMCwzMi4ybDIwLjE4LTE2LjU3DQoJCWwtMy42Mi0zLjYyTDAsMzIuMnoiLz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNTg5OWZmIiBkPSJNMTkuNSwyMy45Mkw4LjI4LDEyLjcxDQoJCWwyLjI0LTIuMjRsMS40OSwxLjVsOC4yMi04LjIybC0xLjQ5LTEuNDlsMS41Ny0xLjU3TDIwLjk5LDBMMzIuMiwxMS4yMWwtMi4yNCwyLjI0bC0xLjUtMS41bC0wLjc1LDAuNzVsLTcuNDcsNy40N2wxLjUsMS41DQoJCWwtMC42NSwwLjY1bC0wLjU4LDAuNThMMTkuNSwyMy45MnoiLz4NCjwvZz4NCjwvc3ZnPg0KDQoNCg0K',
          label: 'Annotations',
          tooltip: 'Toggle Annotations panel',
          cmdName: 'openRightDrawer()',
          cmdParam: 'ANNOT',
        };
        // toolItem.items.push({});
        // toolItem.items.push(annotItem);
        spec.tools.push(annotItem);
      }
      editor.current.uxToolBar.addToolSet(spec);
    }
  };

  const documentViewChanged = (event) => {
    if ( Array.isArray(event.changes) ) {
      // console.log('view changes: ' + JSON.stringify(event.changes));
      event.changes.forEach( change => {
        // console.log('viewChanged: ' + change.changeType);
        if ( change.changeType === 4 ) {
          
          // console.log('documentViewChanged: viewAdded: ' + JSON.stringify(change.view));
          if ( typeof change.view === 'string' && change.view.includes('xxe-image-viewport') ) {
            // editor.current.documentView.executeCommand(XXE.EXECUTE_HELPER, 'changeImage', '');
            // console.log('documentViewChanged: image-viewport viewAdded: ' + JSON.stringify(change.view));
            const xmlDoc = xmlParser.parseFromString(change.view, "application/xml");
            const items = xmlDoc.getElementsByTagName('xxe-image-viewport');
            if ( items.length > 0 ) {
              const id = items[0].parentElement?.getAttribute('id');
              if (id) {
                const st = editor.current['uxState'];
                let vvs = st.views;
                if ( !vvs ) {
                  vvs = {};
                }
                vvs[id] = true;
                st.views = vvs;

                const pview = document.getElementById(id);
                if (pview) {
                  const ivs = pview.getElementsByTagName('xxe-image-viewport');
                  const view = ivs.length > 0 ? ivs[0] : null;
                  if (view && view.localName === 'xxe-image-viewport') {
                    // console.log('Element name = ' + view.localName);
                    setSelectedNode(null);
                    view.chooseImage(new Event('chooseImage'));
                  }

                }
              }
            }
          }
          

        } else if ( change.changeType === 3) {
          // console.log('documentView replaced: ' + change.view);
          if (typeof change.view === 'string' && change.view.includes('xxe-image-viewport')) {
            
            // we may get a new image by replacing an existing view
            const xmlDoc = xmlParser.parseFromString(change.view, "application/xml");
            const items = xmlDoc.getElementsByTagName('xxe-image-viewport');
            if (items.length > 0) {
              const st = editor.current['uxState'];
              let vvs = st.views;
              if ( !vvs ) {
                vvs = {};
                // load the initial image views
                // we only keep image views at the moment
                for(let i=0; i<items.length; i++) {
                  const item = items[i];
                  const iid = item.parentElement?.getAttribute('id');
                  if ( iid ) {
                    vvs[iid] = true;
                  }
                }
                st.views = vvs;
              } else if (items.length === 1) { // handle only a single insertion
                const id = items[0].parentElement?.getAttribute('id');
                if (id) {
                  if (!vvs[id]) {
                    vvs[id] = true;
                    st.views = vvs;
                    // first time seing this image, open media chooser
                    const pview = document.getElementById(id);
                    if (pview) {
                      const ivs = pview.getElementsByTagName('xxe-image-viewport');
                      const view = ivs.length > 0 ? ivs[0] : null;
                      if (view && view.localName === 'xxe-image-viewport') {
                        // console.log('Element name = ' + view.localName);
                        // check if there's already an image
                        const imgs = view.getElementsByTagName('img');
                        if ( !imgs || imgs.length === 0 ) {
                          setSelectedNode(null);
                          view.chooseImage(new Event('chooseImage'));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    }
    
  };

  const loadInitialIdTagMap = (value) => {
    try {
      const m = JSON.parse(value);
      if ( m ) {
        const st = editor.current['uxState'];
        st.idTagMap = m;
      }
    } catch (error) {
      console.log('Error loading ID/Tag map: ' + error);
    };
  };

  const handleNewTag = (id, tag) => {
    if ( tag === 'internalXRef' ) {
      setInternalLinkChooserDialogOpen(true);
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getElement', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const einfo = JSON.parse(result.value);
                setLinkInfo(einfo);
              }
            }
          }).catch(error => {
            console.log('Error reading element info: ' + error);
          });
    } else if ( tag === 'externalXRef' ) {
      console.log('Opening external link tag...');
      setExternalLinkChooserDialogOpen(true);
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getElement', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const einfo = JSON.parse(result.value);
                setExternalLinkInfo(einfo);
              }
            }
          }).catch(error => {
            console.log('Error reading element info: ' + error);
          });
    } else if ( tag === 'contentInclusion' ) {
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getElement', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const einfo = JSON.parse(result.value);
                setContentInclusionInfo(einfo);
                if ( einfo.attributes?.type) {
                  setContentInclusionValue(einfo.attributes.type);
                } else {
                  setContentInclusionValue('');
                }
                console.log('Document profile: ' + JSON.stringify(documentProfile) + ' DU profile: ' + du.targetProfile);
                if ( du.targetProfile === 'QRH' ) {
                  setContentInclusionParam({values: QRH_INCLUSIONS});
                } else {
                  setContentInclusionParam({values: GEN_INCLUSIONS});
                }
              }
            }
            setContentInclusionDialogOpen(true);
          }).catch(error => {
            console.log('Error reading element info: ' + error);
          });
    } else if ( tag === 'footnoteref' ) {
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getFootnoteRefInfo', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const frinfo = JSON.parse(result.value);
                setFootnoteRefInfo(frinfo);
                
              }
            }
            setFootnoteRefChooserDialogOpen(true);
          }).catch(error => {
            console.log('Error reading element info: ' + error);
          });
    } else if ( tag === 'emphasis') {
      setPropertyNode({
        tag: 'emphasis',
        attributes: { id: id, color: '#000000'},
      });
      setColorDialogValue('#000000');
      // setColorDialogOpen(true);
      setRightDrawerOpen(true);
      setRightDrawerPanel('PROP');
    } else if ( tag === 'table' ) {
      // console.log('New tag table, opening property panel...');
      setRightDrawerOpen(true);
      setRightDrawerPanel('PROP');
    }
    if ( id ) {
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getEffectivity', '')
            .then(result => {
              if (result?.value) {
                try {
                    const eff = JSON.parse(result.value);
                    if ( eff?.effectivity ) {
                      const st = editor.current['uxState'];
                      if ( st?.docEff ) {
                        st.docEff[id] = eff;
                      }
                    }
                } catch (error) {
                  console.log('error parsing effectivity: ' + error);
                }
              }
            });
    }
  };

  const handleFootnoteRefInfoSave = (value) => {
    // console.log('LinkChooser save = ' + JSON.stringify(value));
    setFootnoteRefChooserDialogOpen(false);
    const finfo = { attributes: {linkend: value.linkend}};
  
    // console.log('ContentInclusion save = ' + JSON.stringify(nincl));
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setElement', JSON.stringify(finfo))
      .then( result => {
        if ( result?.status !== XXE.COMMAND_RESULT_DONE ) {
          console.log('Error setting footnoteref');
        }
      });
  };

  const footnoteRefInfoCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(true);

      return res;
    }
    setFootnoteRefChooserDialogOpen(true);
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getFootnoteRefInfo', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const finfo = JSON.parse(result.value);
                setFootnoteRefInfo(finfo);
              }
            }
          }).catch(error => {
            console.log('Error reading footnoteref info: ' + error);
          });
    return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);
  };

  const parseNodePathItems = (nodePathItems) => {
    const nodes = [];
    for(let i=0; i<nodePathItems.length; i+=3) {
      const item = {
        id: nodePathItems[i],
        tag: nodePathItems[i+1],
        attributes: {},
        selected: false,
      };
      const tokens = nodePathItems[i+2].split('\n');
      let j=0;
      if ( tokens[j] === 'sel') {
        item.selected = true;
      }
      j++;
      for( ; j<tokens.length; j+=2) {
        item.attributes[tokens[j]] = tokens[j+1];
      }
      nodes.push(item);
      /*
      if ( item.selected ) {
        break;
      }
      */
    }
    return nodes;
  };

  const loadPropertyPanel = (nodePathItems) => {
    if ( !Array.isArray(nodePathItems) ) {
      return;
    }
    /*
      nodePathItems is an array containing 3 items per node in the XML hierarchy of the selection:
      [nodeViewId, tagName, attributes]
      The attributes is a string separated by new lines of attributeName \n attributeValue
      if attributes starts with sel\n , this is the selected node.

      We first locate the selection node and climb up until we find a node that has known properties, or NONE otherwise
    */
    // divide into more manageable objects
    const nodes = parseNodePathItems(nodePathItems);
    // console.log('pathItems: ' + JSON.stringify(nodePathItems));
    // console.log('pathNodes: ' + JSON.stringify(nodes));
    let sel = false;
    let found = false;
    for(let i=nodes.length-1; i >= 0; i--) {
      if ( nodes[i].selected ) {
        sel = true;
        setSelectedElement(nodes[i]);
      }
      if ( sel ) {
        switch (nodes[i].tag ) {
          case 'emphasis':
            setPropertyNode(nodes[i]);
            setPropertyPanel('EMPHASIS');
            // console.log('Found emphasis: ' + JSON.stringify(nodes[i]));
            found = true;
            break;
          case 'command':
          case 'challengeResponse':
            setPropertyNode(nodes[i]);
            setPropertyPanel('CHALLENGE_RESPONSE');
            found = true;
            break;
          case 'goToStep':
            setPropertyNode(nodes[i]);
            setPropertyPanel('GOTO_STEP');
            found = true;
            break;
          case 'goToChecklist':
            setPropertyNode(nodes[i]);
            setPropertyPanel('GOTO_CHECKLIST');
            found = true;
            break;
          case 'table':
          case 'colspec':
          case 'tgroup':
          case 'thead':
          case 'tfoot':
          case 'tbody':
            setPropertyNode(nodes[i]);
            setPropertyPanel('TABLE_ENTRY');
            found = true;
            break;
          case 'row':
            setPropertyNode(nodes[i]);
            setPropertyPanel('TABLE_ENTRY');
            found = true;
            const rowProps = {
              'COLSPAN': 1,
              'pasteColumnBefore': false, 
              'pasteColumnAfter': false, 
              'pasteRowBefore': false, 
              'pasteRowAfter': false,
            };
            ['pasteRowBefore', 'pasteRowAfter'].forEach(cmd => {
              editor.current.documentView.executeCommand(XXE.EXECUTE_TEST, 'ucs.tableEdit', cmd)
                .then(result => {
                  console.log('Execute test: ' + cmd + ' : ' + JSON.stringify(result) + ' typeof result = ' + (typeof result));
                  rowProps[cmd] = result;
                  const pnode = {...nodes[i]};
                  if (!Array.isArray(pnode.properties)) {
                    pnode.properties = {
                    };
                  }
                  pnode.properties['COLSPAN'] = rowProps['COLSPAN'];
                  pnode.properties['pasteColumnBefore'] = rowProps['pasteColumnBefore'];
                  pnode.properties['pasteColumnAfter'] = rowProps['pasteColumnAfter'];
                  pnode.properties['pasteRowBefore'] = rowProps['pasteRowBefore'];
                  pnode.properties['pasteRowAfter'] = rowProps['pasteRowAfter'];
                  setPropertyNode(pnode);
                }).catch(error => {
                  console.log('Error reading element info: ' + error);
                });
            });
            break;
          case 'entry':
            setPropertyNode(nodes[i]);
            setPropertyPanel('TABLE_ENTRY');
            found = true;
            const param = JSON.stringify({
              name: 'entry',
              attributes: {...nodes[i].attributes}
            });
            const extraProps = {
              'COLSPAN': 1,
              'pasteColumnBefore': false, 
              'pasteColumnAfter': false, 
              'pasteRowBefore': false, 
              'pasteRowAfter': false,
            };
            
            editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getElementInfo', param)
              .then(result => {
                // console.log('Changed CTX to: ' + result);
                if (result?.status === XXE.COMMAND_RESULT_DONE) {
                  if (result?.value) {
                    // console.log('getElementInfo: ' + result.value);
                    const einfo = JSON.parse(result.value);
                    if ( einfo?.properties?.COLSPAN ) {
                      extraProps['COLSPAN'] = einfo.properties.COLSPAN;
                      const pnode = {...nodes[i]};
                      if ( !Array.isArray(pnode.properties) ) {
                        pnode.properties = {
                          COLSPAN: einfo.properties.COLSPAN,
                        };
                      }
                      pnode.properties['COLSPAN'] = einfo.properties.COLSPAN;
                      pnode.properties['pasteColumnBefore'] = extraProps['pasteColumnBefore'];
                      pnode.properties['pasteColumnAfter'] = extraProps['pasteColumnAfter'];
                      pnode.properties['pasteRowBefore'] = extraProps['pasteRowBefore'];
                      pnode.properties['pasteRowAfter'] = extraProps['pasteRowAfter'];
                      
                      setPropertyNode(pnode);
                    }
                  }
                }
              }).catch(error => {
                console.log('Error reading element info: ' + error);
              });
            ['pasteColumnBefore', 'pasteColumnAfter', 'pasteRowBefore', 'pasteRowAfter'].forEach(cmd => {
              editor.current.documentView.executeCommand(XXE.EXECUTE_TEST, 'ucs.tableEdit', cmd)
                .then(result => {
                  console.log('Execute test: ' + cmd + ' : ' + JSON.stringify(result) + ' typeof result = ' + (typeof result));
                  extraProps[cmd] = result;
                  const pnode = {...nodes[i]};
                  if (!Array.isArray(pnode.properties)) {
                    pnode.properties = {
                    };
                  }
                  pnode.properties['COLSPAN'] = extraProps['COLSPAN'];
                  pnode.properties['pasteColumnBefore'] = extraProps['pasteColumnBefore'];
                  pnode.properties['pasteColumnAfter'] = extraProps['pasteColumnAfter'];
                  pnode.properties['pasteRowBefore'] = extraProps['pasteRowBefore'];
                  pnode.properties['pasteRowAfter'] = extraProps['pasteRowAfter'];
                  setPropertyNode(pnode);
                }).catch(error => {
                  console.log('Error reading element info: ' + error);
                });
            });
            break;
        }
        if ( found ) {
          break;
        }
      }
    }
    if ( !found ) {
      setPropertyPanel('NONE');
    }

  };

  const editingContextChanged = (event) => {
    // console.log('editingContextChanged: event= ' + JSON.stringify(event.nodePathItems));
    
    if ( editor.current.documentView ) {
      let done = false;
      const st = editor.current['uxState'];
      st.selectedNode = null;
      setSelectedNode(null);
      if (Array.isArray(event.nodePathItems)) {
        // console.log('nodePathItems: ' + JSON.stringify(event.nodePathItems));
        loadPropertyPanel(event.nodePathItems);
        // const nitem = event.nodePathItems.find(n => n.startsWith('sel'));
        const nitemIndex = event.nodePathItems.findIndex(n => n.startsWith('sel'));
        let nitem;
        let tag;
        if ( nitemIndex >= 0 ) {
          nitem = event.nodePathItems[nitemIndex];
          if ( (nitemIndex - 1) >= 0 ) {
            tag = event.nodePathItems[nitemIndex-1];
          }
        }
        // console.log('editingContextChanged: event selection = ' + JSON.stringify(nitem));
        done = true;
        if (nitem) {
          const tokens = nitem.split('\n');
          st.selectedNode = tokens;
          setSelectedNode(tokens);
          // console.log('Tokens: ' + JSON.stringify(tokens));
          const i = tokens.findIndex(s => s === 'id');
          if (i >= 0 && i < tokens.length - 1) {
            const id = tokens[i + 1];
            // console.log('sel id = ' + id);
            if (id !== st.selectedId) {

              st.selectedId = id;
              setSelectedId(id);
              if ( !st.idTagMap[id] ) {
                st.idTagMap[id] = tag;
                handleNewTag(id, tag);
                // console.log('editingContextChange: <' + tag + ' id="' + id + '">');
              }
              
              setEnableEff(true);
              if (st.docEff) {
                const eff = st.docEff[id];
                if (eff) {

                  setSelectedEff(eff);
                  setPrevEff(eff);
                  st.selectedEff = eff;
                  if (Array.isArray(eff.effectivity)) {
                    if (eff.effectivity.length > 0) {
                      eff.effectivity.sort((a, b) => a.valueSortKey.localeCompare(b.valueSortKey));
                      const v = eff.effectivity.reduce((sum, current) => sum !== '' ? sum + ',' + current.label : current.label, '');
                      setEffValue(v);
                      const ids = eff.effectivity.map(e => e.key);
                      setSelectedEffItems(ids);
                    } else if (st.defaultEff) {
                      // const defEff = effMap[effDefaultKey];
                      // console.log('DEF KEY: ' + st.defaultEff.key + ' ' + JSON.stringify(st.defaultEff));

                      setEffValue(st.defaultEff.label);
                      setSelectedEffItems([st.defaultEff.key]);
                      setPrevEff(null);
                    } else {
                      setEffValue('');
                      setSelectedEffItems([]);
                      setPrevEff(null);
                    }
                  } else {
                    setEffValue('');
                    setSelectedEffItems([]);
                    setPrevEff(null);
                  }
                } else {
                  setEffValue('');
                  setSelectedEffItems([]);
                  setPrevEff(null);
                }
              } else {
                setEffValue('');
                setSelectedEffItems([]);
                setPrevEff(null);
              }
              
            } // if is new id
            // if id present
            if ( st.docAnnot ) {
              const annot = st.docAnnot[id];
              if ( annot ) {
                setSelectedAnnot(annot);
                st.selectedAnnot = annot;
              } else {
                setSelectedAnnot(null);
                st.selectedAnnot = null;
              }
              
            } else {
              setSelectedAnnot(null);
              st.selectedAnnot = null;
            }
            console.log('Set select annot: ' + JSON.stringify(st.selectedAnnot))
          } else {
            // console.log('sel no id!');
            if (st.selectedId !== '') {
              st.selectedId = '';
              setSelectedId('');
              setEffValue('');
              setSelectedEffItems([]);
              setPrevEff(null);
              setSelectedAnnot(null);
            }
          }
        } else {
          if (st.selectedId !== '') {
            st.selectedEff = null;
            st.selectedId = '';
            st.selectedNode = null;
            st.selectedAnnot = null;
            setSelectedId('');
            setEffValue('');
            setSelectedEffItems([]);
            setSelectedEff(null);
            setPrevEff(null);
            setEnableEff(false);
            setSelectedAnnot(null);
          }
        }
      }
      
    }
  };

  const openRightDrawerCmd = (state, docView, param) => {

    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(true);

      return res;
    }
    const drawerOpen = editor.current?.uxState?.rightDrawerOpen;
    const drawerPanel = editor.current?.uxState?.rightDrawerPanel;
    // console.log('drawerOpen: ' + drawerOpen + ', drawerPanel: ' + drawerPanel + ', new drawerPanel: ' + param);
    if ( !drawerOpen ) {
      setRightDrawerOpen(rightDrawerOpen => !rightDrawerOpen);
    } else if ( param === drawerPanel ) {
      setRightDrawerOpen(rightDrawerOpen => !rightDrawerOpen);
    }
    if ( param === 'PROP' ) {
      setRightDrawerPanel('PROP');
    } else if ( param === 'ANNOT' ) {
      setRightDrawerPanel('ANNOT');
    } else {
      setRightDrawerPanel('EFF');
    }
    return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);
  };

  const openLinkChooserCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(true);

      return res;
    }
    setInternalLinkChooserDialogOpen(true);
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getElement', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const einfo = JSON.parse(result.value);
                setLinkInfo(einfo);
              }
            }
          }).catch(error => {
            console.log('Error reading element info: ' + error);
          });
    return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);
  };

  const moveMarkCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(true);

      return res;
    }
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.moveMark', '')
        .then( result => {
          if ( result?.value ) {  
            
          }
          return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);

        });
    

  };

  const toggleLeftSidebarCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(false);

      return res;
    }
    if ( editor.current.uxState ) {
      if ( editor.current.uxState.showLeftBar ) {
        editor.current.uxState.showLeftBar = false;
        // editor.current.uxState.showLeftBarSections = false;
        docView.showLeftBar(false);
      } else {
        editor.current.uxState.showLeftBar = true;
        // editor.current.uxState.showLeftBarSections = true;
        docView.showLeftBar(true, { 
            sections: editor.current.uxState['showLeftBarSections'], 
            annotations: editor.current.uxState['showLeftBarAnnotations'],
          });
      }
    }
  };

  const toggleLeftSidebarItemCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      if ( param === 'sections' ) {
        res.push(editor.current?.uxState?.showLeftBarSections);
      } else if ( param === 'annotations' ) {
        res.push(editor.current?.uxState?.showLeftBarAnnotations);
      } else {
        res.push(false);
      }

      return res;
    }
    if (editor.current?.uxState ) {
      let key;
      switch(param) {
        case 'sections':
          key = 'showLeftBarSections';
          break;
        case 'annotations':
          key = 'showLeftBarAnnotations';
          break;
        default:
          key = undefined;
          break;
      }
      if ( key ) {
        if ( editor.current.uxState[key] ) {
          editor.current.uxState[key] = false;
        } else {
          editor.current.uxState[key] = true;
        }
        editor.current.uxState['showLeftBar'] = editor.current.uxState['showLeftBarSections'] || editor.current.uxState['showLeftBarAnnotations'];
        docView.showLeftBar(editor.current.uxState['showLeftBar'], 
          { sections: editor.current.uxState['showLeftBarSections'], 
            annotations: editor.current.uxState['showLeftBarAnnotations'],
          });
      }
    }
  };

  
  const editContentInclusionCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(true);

      return res;
    }
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getElement', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const einfo = JSON.parse(result.value);
                setContentInclusionInfo(einfo);
                if ( einfo.attributes.type ) {
                  setContentInclusionValue(einfo.attributes.type);
                } else {
                  setContentInclusionValue('');
                }
                setContentInclusionParam(param);
              }
              setContentInclusionDialogOpen(true);
            }
          }).catch(error => {
            console.log('Error reading element info: ' + error);
          });
    return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);
  };

  const handleContentInclusionSave = (value, config) => {
    // console.log('LinkChooser save = ' + JSON.stringify(value));
    setContentInclusionDialogOpen(false);
    const nincl = { attributes: {type: value}};
    if ( value === 'TOC' ) {
      nincl.attributes['config'] = JSON.stringify(config);
    }
    // console.log('ContentInclusion save = ' + JSON.stringify(nincl));
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setElement', JSON.stringify(nincl))
      .then( result => {
        if ( result?.status !== XXE.COMMAND_RESULT_DONE ) {
          console.log('Error setting content inclusion');
        }
      });
  };

  const editLinkCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(true);

      return res;
    }
    /*
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.moveMark', '')
        .then( result => {
          if ( result?.value ) {  
            
          }
          return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);

        });
    */
    // console.log('editLink: id=' + param);
    // setInternalLinkChooserDialogOpen(true);
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getElement', '')
          .then(result => {
            // console.log('Changed CTX to: ' + result);
            if (result?.status === XXE.COMMAND_RESULT_DONE) {
              if (result?.value) {
                const einfo = JSON.parse(result.value);
                if ( einfo.name === 'internalXRef') {
                  setLinkInfo(einfo);
                  setInternalLinkChooserDialogOpen(true);
                } else if ( einfo.name === 'externalXRef' ) {
                  setExternalLinkInfo(einfo);
                  setExternalLinkChooserDialogOpen(true);
                }
              }
            }
          }).catch(error => {
            console.log('Error reading element info: ' + error);
          });
    return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);
  };

  const handleInternalLinkSave = (value) => {
    // console.log('LinkChooser save = ' + JSON.stringify(value));
    setInternalLinkChooserDialogOpen(false);
    const nlink = { ...linkInfo };
    if ( value.type !== 'LIT' ) {
      nlink.text = '';
    } else {
      nlink.text = value.preview;
    }
    nlink.attributes['location'] = value.location;
    nlink.attributes['linkend'] = value.linkend;
    nlink.attributes['preview'] = value.preview;
    console.log('InternalLinkChooser save = ' + JSON.stringify(nlink));
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setElement', JSON.stringify(nlink))
      .then( result => {
        if ( result?.status !== XXE.COMMAND_RESULT_DONE ) {
          console.log('Error setting link');
        }
      });
  };

  const handleExternalLinkSave = (value) => {
    console.log('External LinkChooser save = ' + JSON.stringify(value));
    setExternalLinkChooserDialogOpen(false);
    const nlink = {...externalLinkInfo};
    if ( value.type !== 'LIT' && value.type !== 'HREF') {
      nlink.text = '';
    } else {
      nlink.text = value.preview;
    }
    if ( value.type === 'HREF' ) {
      nlink.attributes['href'] = value.href;
      nlink.attributes['location'] = null;
      nlink.attributes['linkend'] = null;
      nlink.attributes['preview'] = null;
    } else {
      nlink.attributes['href'] = null;
      nlink.attributes['location'] = value.location;
      nlink.attributes['linkend'] = value.linkend;
      nlink.attributes['preview'] = value.preview;
    }
    console.log('ExternalLinkChooser save = ' + JSON.stringify(nlink));
    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setElement', JSON.stringify(nlink))
      .then( result => {
        if ( result?.status !== XXE.COMMAND_RESULT_DONE ) {
          console.log('Error setting link');
        }
      });
  };

  const handleEffectivityClick = (eff) => {

  };

  const isEffectivitySelected = (eff) => {
    if ( selectedEff ) {
      const seff = editor.current.uxState.selectedEff;
      const ss = selectedEff.effectivity?.find( e => e.value === eff.value);
      // console.log('Selected: ' + JSON.stringify(eff) + ' => ' + JSON.stringify(seff));
      if ( ss ) {
        // console.log('SELECTED: ' + JSON.stringify(eff));
        return true;
      }
    }
    return false;
  }

  const saveSelectedAnnot = (annot) => {
    // console.log('Saving annotation: ' + JSON.stringify(annot));
    const st = editor.current['uxState'];
    if ( st?.docAnnot ) {
      st.docAnnot[annot.id] = annot;
      setDocAnnot(st.docAnnot);
      setSelectedAnnot(annot);
      const param = JSON.stringify(annot);
      const docView = editor.current.documentView;
      return docView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setRevisionNote', param)
        .then(result => {
          if (result.status === XXE.COMMAND_RESULT_DONE) {
            setSaveNeeded(true);
            if (result?.value) {
                const entries = JSON.parse(result.value);
                if ( Array.isArray(entries) ) {
                  entries.forEach( entry => {
                    st.docAnnot[entry.id] = entry;
                    if ( annot.id === entry.id ) {
                      //console.log('Setting selected annotation = ' + JSON.stringify(entry));
                      setSelectedAnnot(entry);
                    }
                    setDocAnnot(st.docAnnot);
                  });
                }
            }
          }
          return result;
        });
    }
  }

  const handleCreateTableCmd = (state, docView, param) => {
    if (state) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(true);
      res.push(null);
      res.push(true);

      return res;
    }
    setCreateTableDialogOpen(true);
    return new XXE.CommandResult(XXE.COMMAND_RESULT_DONE);  
  };

  const handleCreateTableSave = (options) => {
    setCreateTableDialogOpen(false);
    const docView = editor.current?.documentView;
    if (docView) {
      const params = {
        position: 'AFTER',
        ...options
      };
      docView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.addTable_LOCAL', JSON.stringify(params))
        .then(result => {
          if (result.status === XXE.COMMAND_RESULT_DONE) {
            setRightDrawerOpen(true);
            setRightDrawerPanel('PROP');
          }
          return result;
        });
    }
  };

  const setEffectivityCmd = (state, docView, param) => {
    const st = editor.current['uxState'];

    if ( state ) {
      // const selected = getSelectedNode(docView);
      const res = [];
      res.push(false);
      res.push(null);
      res.push(false);

      
      
      if ( st.selectedEff ) {
        // console.log('Selected eff = ' + JSON.stringify(selectedEff));
        const eff = st.effCmdMap[param];
        // console.log('Cmd eff = ' + JSON.stringify(eff));
        if ( eff ) {
          res[0] = true;
          const seff = st.selectedEff.effectivity?.find(e => e.value === eff.value);
          if ( seff ) {
            res[2] = true;
          } else {
            
          }
        }
      }
      
      return res;
    }
    
    return docView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setEffectivity', param)
      .then( result => {
        if (result.status === XXE.COMMAND_RESULT_DONE) {
          setSaveNeeded(true);
          const eff = st.effCmdMap[param];
          if (eff) {
            if (st.selectedEff) {
              if (!st.selectedEff.effectivity) {
                st.selectedEff.effectivity = [];
                st.selectedEff.effectivity.push(eff);
              } else {
                const index = st.selectedEff.effectivity.findIndex(e => e.value === eff.value);
                if (index >= 0) {
                  st.selectedEff.effectivity.splice(index, 1);
                  // console.log("Removing " + JSON.stringify(eff) + ' from ' + JSON.stringify(st.selectedEff));
                } else {
                  st.selectedEff.effectivity.push(eff);
                }
              }
            }
          }
        }
        return result;
      });
  }

  const parseRevNoteTable = (metadata, tableName, typeName, dannot) => {
    const revTable = metadata.tables.find(t => t.name === tableName);
    // console.log('RevisionNoteHighlight: ' + JSON.stringify(highTable));
    if (Array.isArray(revTable?.entries)) {
      revTable.entries.forEach(h => {
        let hentry = dannot[h.properties?.duId];
        if (!hentry) {
          hentry = {
            id: h.properties?.duId,
            annotations: [],
          };
        }
        if (hentry.id) {
          dannot[hentry.id] = hentry;
        }
        const ant = hentry.annotations.find(a => a.id === h.id);
        if (!ant && h.properties) {
          const ro = typeof h.properties.readOnly === 'boolean' ? h.properties.readOnly : ('true' === h.properties.readyOnly);
          const ec = typeof h.properties.isEditionClosed === 'boolean' ? h.properties.isEditionClosed: ('true' === h.properties.isEditionClosed);
          const pe = typeof h.properties.isPersistent === 'boolean' ? h.properties.isPersistent : ('true' === h.properties.isPersistent);
          hentry.annotations.push({
            type: typeName,
            id: h.id,
            duId: h.properties.duId,
            content: h.properties.content,
            modificationDate: h.properties.modificationDate,
            readOnly: ro,
            isPersistent: pe,
            isEditionClosed: ec,
            user: h.properties.user,
          });
        }
      });
    }
  }

  const parseAnnotations = (metadata) => {
    const dannot = {};
    const dfiles = {};
    parseRevNoteTable(metadata, 'RevisionNoteHighlight', 'Highlight', dannot);
    parseRevNoteTable(metadata, 'RevisionNoteEditorial', 'Editorial', dannot);
    parseRevNoteTable(metadata, 'RevisionNoteApproval', 'Approval', dannot);
    parseRevNoteTable(metadata, 'RevisionNoteInterpretation', 'Interpretation', dannot);

    const fileTable = metadata.tables.find(t => t.name === 'CollateralFile');
    const colTable = metadata.tables.find(t => t.name === 'Collateral');
    if ( colTable && fileTable ) {
      fileTable.entries.forEach( f => {
        if (f.id && f.properties ) {
          dfiles[f.id] = {
            id: f.id,
            key: f.key,
            originalFilePath: f.properties?.originalFilePath,
            mimeType: f.properties?.mimeType,
            repositoryFilePath: f.properties?.repositoryFilePath,
            repositoryFileSaved: f.properties?.repositoryFileSaved,
          };
        }
      });
      colTable.entries.forEach( h => {
        let hentry = dannot[h.properties?.duId];
        if (!hentry) {
          hentry = {
            id: h.properties?.duId,
            annotations: [],
          };
        }
        if (hentry.id) {
          dannot[hentry.id] = hentry;
        }
        const ant = hentry.annotations.find(a => a.id === h.id);
        if (!ant && h.properties) {
          const colFile = h.properties.collateralFile;
          let fid;
          if ( typeof colFile === 'string') {
            fid = colFile;
          } else if ( colFile.value ) {
            fid = colFile.value;
          } else if ( colFile.id ) {
            fid = colFile.id;
          }
          let cf = null;
          if ( fid ) {
            cf = dfiles[fid];
          }
          const ro = typeof h.properties.readOnly === 'boolean' ? h.properties.readOnly : ('true' === h.properties.readyOnly);
          const ec = typeof h.properties.isEditionClosed === 'boolean' ? h.properties.isEditionClosed: ('true' === h.properties.isEditionClosed);
          hentry.annotations.push({
            type: 'Collateral',
            id: h.id,
            collateral: {
              displayName: h.properties.displayName,
              description: h.properties.description,
              collateralFile: cf,
            },
            duId: h.properties.duId,
            modificationDate: h.properties.modificationDate,
            readOnly: ro,
            isEditionClosed: ec,
            user: h.properties.user,
          });
        }
      });
    }
    
    return [ dannot, dfiles ];
  };

  const openDocUnit = (dunit, options) => {
    const entry = dunit?.entry ? dunit.entry : {};
    const dpath = dunit.rootPath + '/' + (entry.contentPath ? entry.contentPath : entry.entryId);
    // openDoc(dpath);
    console.log('Open entryId: ' + entry.entryId);
    let eurl = '/api/doc/entry/content/' + entry.entryId;
    if ( dunit.targetProfile ) {
      setDocumentProfile(dunit.targetProfile);
      eurl = eurl + '?target=' + encodeURIComponent(dunit.targetProfile);
    }
    netGet(eurl)
      .then( response => response.json())
      .then(info => {

        const config = info.config;
        let nodes = config?.properties?.eff?.source ? config.properties.eff.source : [];
        if (!Array.isArray(nodes)) {
          nodes = [];
        }
        const flist = [];
        const treeList = [];
        let elist = [];
        const seq = [0];
        const exp = [];
        flattenTree(info.docId, flist, nodes, treeList, elist, exp, seq);
        
        const emap = {};
        const smap = {};
        elist.forEach(item => {
          emap[item.key] = item;
          smap[item.value] = item;
        });
        setEffDefaultKey(null);
        
        // console.log('effTree: ' + JSON.stringify(treeList));
        setExpandedEffItems(exp);
        setEffTree(treeList);
        setEffList(elist);
        setEffMap(emap);
        const deff = {};
        let dannot = {};
        let dfiles = {};
        if ( info.metadata && Array.isArray(info.metadata.tables) ) {
          const effTable = info.metadata.tables.find( t => t.name === 'Effectivity');
          if ( Array.isArray(effTable?.entries) ) {
            effTable.entries.forEach( e => {
              let eentry = deff[e.id];
              if ( !eentry ) {
                eentry = {
                  id: e.id,
                  effectivity: [],
                };
              }
              const eff = smap[e.statement];
              if ( eff ) {
                eentry.effectivity.push(eff);
              }
              deff[e.id] = eentry;
            });
          }
          const annots = parseAnnotations(info.metadata);
          dannot = annots[0];
          dfiles = annots[1];
        }
        setDocEff(deff);
        setDocAnnot(dannot);
        // console.log("ELIST: " + JSON.stringify(elist));

        setOpened(true);
        setTimeout(() => {
          
            closeDocument(false).then(() => {
              editor.current?.addEventListener('contextmenu', (event) => {
                event.preventDefault();
              });
              editor.current?.removeEventListener('documentViewChanged', documentViewChanged);
              // console.log('Opening doc: ' + info.content);
              const loc = new URL(dpath, window.location.href).toString();
              console.log('Opening doc: ' + loc + ': ' + readOnly );
              editor.current?.openDocument(info.content, loc, readOnly)
                .then( () => {
                  if ( elist.length > 0 ) {
                    const spec = {
                      label: 'Metadata',
                      override: true,
                      tools: [],
                    };
                    const cmdMap = {};
                    elist.forEach((eff,index) => {
                      const effItem = {
                        iconName: 'styles',
                        label: "Effectivity",
                        tooltip: "Toggle Effectivity panel",
                        cmdName: "openRightDrawer()",
                        cmdParam: /* JSON.stringify(eff) */ 'EFF',
                        
                      };
                      cmdMap[effItem.cmdParam] = /* eff */ 'EFF';
                      if ( index === 0 ) {
                        spec.tools.push(effItem);
                      }
                    });
                    /*
                    const linkItem = {
                      iconName: 'link',
                      label: 'internalXRef',
                      tooltip: 'Add Internal Link',
                      cmdName: 'openLinkChooser()',
                      cmdParam: '',
                    }
                    spec.tools[0]['items'].push(linkItem);
                    */
                    /*
                    const mitem = {
                      iconName: 'styles',
                      label: 'Move Mark',
                      tooltip: 'Move the mark',
                      cmdName: 'moveMark()',
                      cmdParam: ''
                    };
                    spec.tools[0]['items'].push(mitem);
                    */
                    const propItem = {
                      iconName: 'cog',
                      label: 'Properties',
                      tooltip: "Toggle Properties panel",
                      cmdName: 'openRightDrawer()',
                      cmdParam: 'PROP',
                    };
                    // spec.tools[0]['items'].push({});
                    spec.tools.push(propItem);
                    spec.tools.push({});
                    if ( Array.isArray(editor.current.uxToolBar.metaToolSets) && editor.current.uxToolBar.metaToolSets.length > 0 ) {
                      editor.current.uxToolBar.metaToolSets.forEach( tool => {
                        if ( Array.isArray(tool.tools) ) {
                          tool.tools.forEach( (toolItem, j) => {
                            // spec.tools.push(toolItem);
                            if ( j === 0 && Array.isArray(toolItem.items)) {
                              const annotItem = {
                                iconData: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJQaW5CbHVlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiDQoJIHk9IjBweCIgdmlld0JveD0iMCAwIDMyIDMyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNWQ1ZDYwIiBkPSJNMCwzMi4ybDIwLjE4LTE2LjU3DQoJCWwtMy42Mi0zLjYyTDAsMzIuMnoiLz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNTg5OWZmIiBkPSJNMTkuNSwyMy45Mkw4LjI4LDEyLjcxDQoJCWwyLjI0LTIuMjRsMS40OSwxLjVsOC4yMi04LjIybC0xLjQ5LTEuNDlsMS41Ny0xLjU3TDIwLjk5LDBMMzIuMiwxMS4yMWwtMi4yNCwyLjI0bC0xLjUtMS41bC0wLjc1LDAuNzVsLTcuNDcsNy40N2wxLjUsMS41DQoJCWwtMC42NSwwLjY1bC0wLjU4LDAuNThMMTkuNSwyMy45MnoiLz4NCjwvZz4NCjwvc3ZnPg0KDQoNCg0K',
                                label: 'Annotations',
                                tooltip: 'Toggle Annotations panel',
                                cmdName: 'openRightDrawer()',
                                cmdParam: 'ANNOT',
                              };
                              // toolItem.items.push({});
                              // toolItem.items.push(annotItem);
                              spec.tools.push(annotItem);
                              toolItem.items.forEach( item => spec.tools.push(item));
                            }
                          });
                        }
                      });
                    } else {
                      const annotItem = {
                        iconData: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJQaW5CbHVlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiDQoJIHk9IjBweCIgdmlld0JveD0iMCAwIDMyIDMyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNWQ1ZDYwIiBkPSJNMCwzMi4ybDIwLjE4LTE2LjU3DQoJCWwtMy42Mi0zLjYyTDAsMzIuMnoiLz4NCgk8cGF0aCBtYXJrZXItc3RhcnQ9Im5vbmUiIG1hcmtlci1lbmQ9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNTg5OWZmIiBkPSJNMTkuNSwyMy45Mkw4LjI4LDEyLjcxDQoJCWwyLjI0LTIuMjRsMS40OSwxLjVsOC4yMi04LjIybC0xLjQ5LTEuNDlsMS41Ny0xLjU3TDIwLjk5LDBMMzIuMiwxMS4yMWwtMi4yNCwyLjI0bC0xLjUtMS41bC0wLjc1LDAuNzVsLTcuNDcsNy40N2wxLjUsMS41DQoJCWwtMC42NSwwLjY1bC0wLjU4LDAuNThMMTkuNSwyMy45MnoiLz4NCjwvZz4NCjwvc3ZnPg0KDQoNCg0K',
                        label: 'Annotations',
                        tooltip: 'Toggle Annotations panel',
                        cmdName: 'openRightDrawer()',
                        cmdParam: 'ANNOT',
                      };
                      // toolItem.items.push({});
                      // toolItem.items.push(annotItem);
                      spec.tools.push(annotItem);
                    }

                    // setEffCmdMap(cmdMap);
                    // effCmdMap = cmdMap;
                    // console.log('toolSet SPEC: ' + JSON.stringify(spec));
                    let oldDisplay = editor.current.uxToolBar.style.display;
                    if ( showToolbar ) {
                      // toolbar commands
                      editor.current?.uxToolBar?.addEventListener('contextmenu', (event) => {
                        event.preventDefault();
                      });
                      editor.current.uxToolBar['setEffectivity'] = setEffectivityCmd;
                      editor.current.uxToolBar['openRightDrawer'] = openRightDrawerCmd;
                      editor.current.uxToolBar['openLinkChooser'] = openLinkChooserCmd;
                      editor.current.uxToolBar['moveMark'] = moveMarkCmd;
                      editor.current.uxToolBar['toggleLeftSidebar'] = toggleLeftSidebarCmd;
                      editor.current.uxToolBar['toggleLeftSidebarItem'] = toggleLeftSidebarItemCmd;
                      editor.current.uxToolBar['ucs.addTable_LOCAL'] = handleCreateTableCmd;
                      // documentView command
                      editor.current.documentView['editLink'] = editLinkCmd;
                      editor.current.documentView['editContentInclusion'] = editContentInclusionCmd;
                      editor.current.documentView['footnoteRefInfo'] = footnoteRefInfoCmd;
                      editor.current.uxToolBar.addToolSet(spec);
                      if ( Array.isArray(options?.sections) ) {
                        editor.current.documentView.leftBarTags = options.sections;
                      }
                    } else {
                      editor.current.uxToolBar.style.display = 'none';
                      editor.current.uxStatusPane.style.display = 'none';
                    }
                    editor.current['uxState'] = {
                      effCmdMap: cmdMap,
                      selectedEff: null,
                      docMeta: info.metadata,
                      defaultEff: null,
                      docEff: deff,
                      docAnnot: dannot,
                      docCollatFiles: dfiles,
                      selectedAnnot: null,
                      selectedId: null,
                      selectedNode: null, // array of selected node path 
                      views: null, // cache of views seen in the document
                      oldDisplay: oldDisplay,
                      mediaChooserOpened: false,
                      mediaChooserUrl: '',
                      idTagMap: {},
                      rightDrawerOpen: false,
                      rightDrawerPanel: 'EFF',
                      showLeftBar: true,
                      showLeftBarSections: true,
                      showLeftBarAnnotations: true,
                    };
                    const dinfo = {
                      docId: info.document?.id,
                      title: info.document?.title,
                      tenantId: info.document?.operator,
                      effectivityNamespace: info.document?.namespace,
                      idChannel: info.document?.idChannel,
                      configBaseKey: info.document?.configBaseKey,
                      effectivityConfig: elist,
                      effectivityMap: deff,
                      annotationMap: dannot,
                    };
                    setDocId(info.document?.id);
                    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.loadDocumentContext', JSON.stringify(dinfo))
                      .then( result => {
                        if (result?.status === XXE.COMMAND_RESULT_DONE) {
                          loadInitialIdTagMap(result.value);
                        }
                      }).catch(error => {
                        console.log('Error loading document context: ' + error);
                      });
                    console.log('DU target profile = ' + du.targetProfile);
                    if (du.targetProfile === 'QRH') {
                      setDocumentProfile(du.targetProfile);
                      let url = '/api/doc/tree/' + encodeURIComponent(dinfo.docId) +
                        '?target=QRH_CHECKLIST';
                      console.log('checklist db model url = ' + url);
                      netGet(url)
                        .then(response => response.json())
                        .then(droot => {
                          if (droot) {
                            // console.log("C DB: " + JSON.stringify(droot));
                            const checklistDB = [droot];
                            editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'qrh.setChecklistModel', JSON.stringify(checklistDB))
                              .then(result => {
                                if (result?.status === XXE.COMMAND_RESULT_DONE) {
                                  // OK
                                } else {
                                  console.log("CMD status = " + JSON.stringify(result?.status));
                                }
                              }).catch(error => {
                                console.log('Error loading checklist database: ' + error);
                              });
                          }
                        }).catch(error => {
                          console.log('Error fetching Document tree: ' + error);
                        });
                    }
                    editor.current.removeEventListener('editingContextChanged', editingContextChanged);
                    editor.current.addEventListener('editingContextChanged', editingContextChanged);
                    editor.current.removeEventListener('documentViewChanged', documentViewChanged);
                    editor.current.addEventListener('documentViewChanged', documentViewChanged);
                    editor.current.removeEventListener('documentConfigChanged', documentConfigChanged);
                    editor.current.addEventListener('documentConfigChanged', documentConfigChanged);
                    
                    setRightDrawerOpen(false);
                    setRightDrawerPanel('EFF');
                    
                    /*
                    const binding1 = editor.current.documentView.getAppEventBinding('resize-image');
                    console.log('resize-image binding: ' + JSON.stringify(binding1));
                    const binding2 = editor.current.documentView.getAppEventBinding('rescale-image');
                    console.log('rescale-image binding: ' + JSON.stringify(binding2));
                    */
                  }

                  
                })
                .catch(error => {
                console.log('Error opending document entry: ' + error);
                // editor.current.openDocument(TEMPLATE1, new URL(dpath, window.location.href).toString());
              });
            });
          
        }, 500);

      }).catch(error => console.log('Error opening document entry ' + error));
  };

  const openDoc = (path) => {
    if (editor.current) {
      netGet('/api/fs' + path)
        .then(response => response.text())
        .then(text => {
          // console.log('text: ' + text);
          setOpened(true);
          setTimeout(() => {
            if (text.includes('<description')) {
              closeDocument().then(() => {
                editor.current.openDocument(TEMPLATE1, new URL(path, window.location.href).toString());
              });
            } else {
              closeDocument().then(() => {
                editor.current.openDocument(text, new URL(path, window.location.href).toString()).catch(error => {
                  console.log('Error opending document: ' + error);
                  editor.current.openDocument(TEMPLATE1, new URL(path, window.location.href).toString());
                });
              });
            }
          }, 500);

        }).catch(error => console.log('Error opening document ' + error));
    }
  };

  class UcpResource extends XXE.Resource {
    constructor(uri, data) {
      super(uri, data);
    }
  }
    
  class UcpStorage extends XXE.ResourceStorage {

    constructor(xmlEditor) {
      super(xmlEditor);
    }

    async loadResource(uri) {
      /*
      let p = uri;
      let url = `/api/fs/${p}`;
      if (uri.startsWith('catalog:/')) {
        p = uri.substring(10);
        url = `/api/fs/catalog/${p}`;
      } else if ( uri.startsWith('media:/') ) {
        p = uri.substring(8);
        url = `/api/fs/${p}`;
      }
      */
      const url = new URL(uri);
      const purl = url.pathname.startsWith('/api/fs/') ? url.pathname : '/api/fs' + url.pathname;

      // console.log('Loading resource: ' + purl);
      const resp = await netGet(purl);
      const data = await resp.blob();
      return new UcpResource(uri, data);
    }


    async openResource(options) {
      // console.log('openResource options: ' + JSON.stringify(options));
      setMediaChooserDialogOpen(true);
      // this is a bit ugly, but need to wait for the dialog box to do its thing
      let st = editor.current['uxState'];
      if ( !st ) {
        editor.current['uxState'] = {
          mediaChooserOpened: false,
          mediaChooserUrl: '',
          mediaChooserImage: null,
        };
        st = editor.current['uxState'];
      }
      st.mediaChooserOpened = true;
      await untilCondition(_ => st.mediaChooserOpened == false);
      // console.log('mediaUrl: ' + mediaUrl);
      // console.log('mediaChooserUrl: ' + mediaChooserUrl);
      if (st.mediaChooserUrl == null) {
        // Canceled by user.
        return null;
      }
      let uri = new URL(st.mediaChooserUrl, window.location.href); // await NewsResourceChooser.showDialog(this._newsItems,options);
      return this.loadResource(uri.toString());
    }
  }

  /*
    Need a better way to sync with React. We need to wait for the result of a dialog box.
    Also issue with reading the state of some variables, need to use globals to assure we have the recent value.
   */
  const untilCondition = (conditionFunction) => {

    const poll = resolve => {
      if (conditionFunction()) resolve();
      else setTimeout(_ => poll(resolve), 400);
    }

    return new Promise(poll);
  };

  const handleMediaChooserSave = (url, image) => {
    setMediaUrl(url);
    setMediaChooserDialogOpen(false);
    let st = editor.current['uxState'];
    if ( !st ) {
          editor.current['uxState'] = {
          mediaChooserOpened: false,
          mediaChooserUrl: '',
          mediaChooserImage: null,
        };
        st = editor.current['uxState'];
    }
    // mediaChooserUrl = url;
    // mediaChooserOpened = false;
    st.mediaChooserUrl = url;
    st.mediaChooserImage = image;
    st.mediaChooserOpened = false;
    
  };

  const handleMediaChooserCancel = () => {
    setMediaUrl(null);
    setMediaChooserDialogOpen(false);
    let st = editor.current['uxState'];
    if ( !st ) {
          editor.current['uxState'] = {
          mediaChooserOpened: false,
          mediaChooserUrl: '',
          mediaChooserImage: null,
        };
        st = editor.current['uxState'];
    }
    // mediaChooserUrl = null;
    // mediaChooserOpened = false;
    st.mediaChooserUrl = null;
    st.mediaChooserImage = null;
    st.mediaChooserOpened = false;
  };

  const closeDocument = (disc = true) => {
    if (!editor.current?.documentIsOpened) {
      return Promise.resolve(true);
    } else {
      console.log('Closing document ' + du?.name);
      if (editor?.current) {
        const r = editor.current.closeDocument(/*discardChanges*/ true);
        if ( disc ) {
          editor.current.disconnect();
        }
        return r;
      }
      return Promise.resolve(true);
    }
  };

  const handleLoad = (sample) => {
    /* it doesn't matter, it will auto-connect if not connected yet
      if ( editor.current?.connected ) {
          console.log('editor is connected...');
          
      } else {
          console.log('editor is not connected...');
      }
    */
    closeDocument().then(() => {
      if (sample === 1) {
        editor.current.openDocument(SAMPLE1, new URL('/sample1.xml', window.location.href).toString());
      } else if (sample === 2) {
        // editor.current.openDocument(SAMPLE2, new URL('/sample2.xml', window.location.href).toString());
      } else if (sample === 3) {
        editor.current.openDocument(SAMPLE3, new URL('/sample3.xml', window.location.href).toString());
      }
    });
  };

  const handleSave = (event) => {
    if (editor.current) {
      /*  OK this works
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'efb.getEffectivity', null).then( res => {
        const eff = JSON.parse(res['_value']);
        console.log('GET EFF RESULT = ' + JSON.stringify(eff));
      });
      */
      editor.current.getDocument().then(src => {
        if (du && editor?.current ) {
          const st = editor.current['uxState'];
          if ( st.docMeta ) {
            st.docMeta.tables = [];
          }
          //console.log('handleSave st: ' + JSON.stringify(st));
          editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getEffectivity', 'ALL')
            .then(result => {
              if (result?.value) {
                try {
                  // console.log('All effectivity: ' + result.value);
                  const effList = JSON.parse(result.value);
                  if ( Array.isArray(effList) ) {
                    
                    if ( !st.docMeta ) {
                      st.docMeta = {
                        version: '2.0',
                        "tables": [
                          {
                            "name": 'Effectivity',
                            className: 'uniscope.metadata.Effectivity',
                            "pkey": 'id',
                            "unique": false,
                            "sequence": 0,
                            "sequencePrefix": '',
                            "entries": [],
                          }],
                      };
                    }
                    let effTable = st.docMeta.tables?.find( t => t.name === 'Effectivity');
                    if ( !effTable ) {
                      effTable = {
                        "name": 'Effectivity',
                        className: 'uniscope.metadata.Effectivity',
                        "pkey": 'id',
                        "unique": false,
                        "sequence": 0,
                        "sequencePrefix": '',
                        "entries": [],
                      };
                      st.docMeta.tables.push(effTable);
                    } else if ( !effTable.className ) {
                      effTable.className = 'uniscope.metadata.Effectivity';
                    }
                    effTable.entries = [];
                    effList.forEach( entry => {
                      if ( entry.effectivity ) {
                        entry.effectivity.forEach( eff => {
                          const oeff = {
                            id: entry.id,
                            key: entry.id,
                            className: 'uniscope.metadata.Effectivity',
                            statement: eff.value,
                            effectivity: eff.equation,
                            namespace: eff.namespace,
                            type: ''
                          };
                          
                          effTable.entries.push(oeff);

                        });
                      }
                    });
                  }
                } catch (error) {
                  console.log('error retrieving effectivity = ' + error);
                }
              }
              const sinfo = {
                entry: du.entry,
                content: src,
                metadata: st.docMeta,
                docId: du.entry?.document,
                id: du.entry?.id,
                eid: du.entry?.entryId,
                procId: du.procId,
              };
              editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getRevisionNotes', '')
                .then(result => {
                  if (result?.value) {
                    try {
                      console.log('revNotes: ' + result.value);
                      const revNotes = JSON.parse(result.value);
                      if ( Array.isArray(revNotes) ) {
                        revNotes.forEach( entry => {
                          if (Array.isArray(entry.annotations)) {
                            entry.annotations.forEach(annot => {
                              let tableName = 'RevisionNoteHighlight';
                              let tableClass = 'uniscope.filesystem.metadata.RevisionNoteHighlight';
                              switch(annot.type) {
                                case 'Highlight':
                                  tableName = 'RevisionNoteHighlight';
                                  tableClass = 'uniscope.filesystem.metadata.RevisionNoteHighlight';
                                  break;
                                case 'Editorial':
                                  tableName = 'RevisionNoteEditorial';
                                  tableClass = 'uniscope.filesystem.metadata.RevisionNoteEditorial';
                                  break;
                                case 'Approval':
                                  tableName = 'RevisionNoteApproval';
                                  tableClass = 'uniscope.filesystem.metadata.RevisionNoteApproval';
                                  break;
                                case 'Interpretation':
                                  tableName = 'RevisionNoteInterpretation';
                                  tableClass = 'uniscope.filesystem.metadata.RevisionNoteInterpretation';
                                  break;
                                case 'Collateral':
                                  tableName = 'Collateral';
                                  tableClass = 'uniscope.filesystem.metadata.Collateral';
                                  break;
                               }
                              // console.log('st.docMeta: ' + JSON.stringify(st.docMeta));
                              if (!st.docMeta) {
                                console.log('resetting st.docMeta!!!!');
                                st.docMeta = {
                                  version: '2.0',
                                  "tables": [],
                                };
                              }
                              let revTable = st.docMeta.tables?.find(t => t.name === tableName);
                              if (!revTable) {
                                revTable = {
                                  "name": tableName,
                                  className: tableClass,
                                  "pkey": 'id',
                                  "unique": true,
                                  "sequence": 0,
                                  "sequencePrefix": '',
                                  "entries": [],
                                };
                                st.docMeta.tables.push(revTable);
                                sinfo.metadata = st.docMeta;
                              }
                              let fileTable;
                              if ( tableName === 'Collateral' ) {
                                fileTable = st.docMeta.tables?.find(t => t.name === 'CollateralFile');
                                if ( !fileTable ) {
                                  fileTable = {
                                    "name": 'CollateralFile',
                                    className: 'uniscope.filesystem.metadata.CollateralFile',
                                    "pkey": 'id',
                                    "unique": true,
                                    "sequence": 0,
                                    "sequencePrefix": '',
                                    "entries": [],
                                  };
                                  st.docMeta.tables.push(fileTable);
                                  sinfo.metadata = st.docMeta;
                                }
                              }
                              // if (!Array.isArray(revTable.entries)) {
                              //  revTable.entries = [];
                              // }
                              if ( annot.type === 'Collateral') {
                                revTable.entries.push({
                                  id: annot.id,
                                  key: annot.id,
                                  className: tableClass,
                                  properties: {
                                    id: annot.id,
                                    duId: annot.duId,
                                    modificationDate: annot.modificationDate,
                                    isEditionClosed: annot.isEditionClosed,
                                    readOnly: annot.readOnly,
                                    user: annot.user,
                                    displayName: annot.collateral?.displayName,
                                    description: annot.collateral?.description,
                                    collateralFile: {
                                      value: annot.collateral?.collateralFile?.id,
                                      className: 'uniscope.filesystem.metadata.CollateralFile',
                                    }
                                  }
                                });
                                if (annot.collateral?.collateralFile) {
                                  fileTable.entries.push({
                                    id: annot.collateral.collateralFile.id,
                                    key: annot.collateral.collateralFile.id,
                                    className: 'uniscope.filesystem.metadata.CollateralFile',
                                    properties: {
                                      mimeType: annot.collateral.collateralFile.mimeType,
                                      originalFilePath: annot.collateral.collateralFile.originalFilePath,
                                      repositoryFilePath: annot.collateral.collateralFile.repositoryFilePath,
                                      repositoryFileSaved: annot.collateral.collateralFile.repositoryFileSaved,
                                    }
                                  });
                                }
                              } else {
                                revTable.entries.push({
                                  id: annot.id,
                                  key: annot.id,
                                  className: tableClass,
                                  properties: {
                                    id: annot.id,
                                    duId: annot.duId,
                                    modificationDate: annot.modificationDate,
                                    isPersistent: annot.isPersistent,
                                    isEditionClosed: annot.isEditionClosed,
                                    readOnly: annot.readOnly,
                                    content: annot.content,
                                    user: annot.user,
                                  }
                                });
                              }
                            });
                          }
                        });
                      }
                      
                    } catch (error) {
                      console.log('error retrieving revision status = ' + error);
                    }
                  }
                  console.log('Saving metadata: ' + JSON.stringify(sinfo.metadata));
                  // sinfo.metadata = null; // TODO
                  
                  editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getRevisionStatus', '')
                    .then(result => {
                      if (result?.value) {
                        try {
                          console.log('revMap: ' + result.value);
                          const revMap = JSON.parse(result.value);
                          sinfo.revision = revMap;
                        } catch (error) {
                          console.log('error retrieving revision status = ' + error);
                        }
                      }
                      saveDuEntry(sinfo);
                    }).catch(error => {
                      console.log('Error processing revision status: ' + error);
                      saveDuEntry(sinfo);
                    });
                  }).catch(error => {
                    console.log('Error processing revision notes: ' + error);
                    editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.getRevisionStatus', '')
                      .then(result => {
                        if (result?.value) {
                          try {
                            // console.log('revMap: ' + result.value);
                            const revMap = JSON.parse(result.value);
                            sinfo.revision = revMap;
                          } catch (error) {
                            console.log('error retrieving revision status = ' + error);
                          }
                        }
                        saveDuEntry(sinfo);
                      }).catch(error => {
                        console.log('Error processing revision status: ' + error);
                        saveDuEntry(sinfo);
                      });
                  });
              // console.log('To SAVE metadata: ' + JSON.stringify(sinfo?.metadata));
              /*
              netPost('/api/doc/entry/save', sinfo)
                .then(response => response.json())
                .then(node => {
                  if (node) {
                    // console.log('document saved correctly');
                    
                    if (node.label) {
                      const prefix = node.entry?.code && node.entry.code !== '' && node.entry.code !== '-' ? node.entry.code + ' ' : '';
                      setEditorLabel(prefix + node.label);
                    }
                    editor.current.saveDocument().then( (saved) => {
                      setSaveNeeded(false);
                      editor.current.showStatus('Document "' + editorLabel + '" saved successfully.');
                      console.log('Saved document "' + editorLabel + '"');
                      if ( typeof onSaved === 'function') {
                        onSaved(du);
                      }
                    });
                    
                    
                  }
                }).catch(error => {
                  console.log('Error saving document:' + error);
                  editor.current.showStatus('Error saving document: ' + error);
                });
                */
            });
          

        } else {
          netPostExt('/api/doc/fs/save/' + encodeURIComponent(path), src, { 'Content-Type': 'text/xml' })
            .then(response => {
              if (response.ok) {
                console.log('document saved correctly');
                editor.current.saveDocument().then (saved => {
                    setSaveNeeded(false);
                });
                
              }
            }).catch(error => {
              console.log('Error saving document:' + error);
              editor.current.showStatus('Error saving document: ' + error);
            });
        }
      });
    }
  };

  const saveDuEntry = (sinfo) => {
    netPost('/api/doc/entry/save', sinfo)
      .then(response => response.json())
      .then(node => {
        if (node) {
          // console.log('document saved correctly');

          if (node.label) {
            const prefix = node.entry?.code && node.entry.code !== '' && node.entry.code !== '-' ? node.entry.code + ' ' : '';
            setEditorLabel(prefix + node.label);
          }
          editor.current.saveDocument().then((saved) => {
            setSaveNeeded(false);
            editor.current.showStatus('Document "' + editorLabel + '" saved successfully.');
            console.log('Saved document "' + editorLabel + '"');
            if (typeof onSaved === 'function') {
              onSaved(du);
            }
          });


        }
      }).catch(error => {
        console.log('Error saving document:' + error);
        editor.current.showStatus('Error saving document: ' + error);
      });
  };

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  }));


  const handleUndo = () => {
    if ( prevEff ) {
      let eff = {
        id: prevEff.id,
        effectivity: [...prevEff.effectivity],
      }
      const st = editor.current['uxState'];
      const param = JSON.stringify(eff);
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setEffectivity', param)
        .then(result => {
          if (result?.status === XXE.COMMAND_RESULT_DONE) {
            let done = false;
            if (result?.value) {
              try {
                const effs = JSON.parse(result.value);
                // console.log('undo setEff value=' + JSON.stringify(effs));
                if (Array.isArray(effs) && effs.length > 0) {
                  const deff = { ...docEff };
                  effs.forEach((seff, index) => {
                    if (index === 0) {
                      eff = seff;
                    }
                    if (seff.id) {
                      // console.log('storing eff id=' + seff.id);
                      deff[seff.id] = seff;
                      st.docEff[eff.id] = seff;
                      st.selectedId = seff.id;
                    }
                  });
                  setDocEff(deff);
                } else {
                  // clear, let the editing context change event reset the context
                  done = true;
                }
              } catch (error) {
                console.log('Error paring setEff value: ' + error);
              }
            } else {
              // clear, let the editing context change event reset the context
              done = true;
            }

            if (!eff) {
              eff = {
                id: prevEff.id,
                effectivity: [...prevEff.effectivity],
              }
            }
            if ( ! Array.isArray(eff.effectivity) ) {
              eff.effectivity = [];
            }

            setSaveNeeded(true);
            
            st.selectedEff = eff;
            st.selectedId = eff.id;
            setSelectedEff(eff);
            eff.effectivity.sort( (a,b) => a.valueSortKey.localeCompare(b.valueSortKey));
            const v = eff.effectivity.reduce((sum, current) => sum !== '' ? sum + ',' + current.label : current.label, '');
            if (eff.effectivity.length > 0) {
              setEffValue(v);
              const ids = eff.effectivity.map(e => e.key);
              setSelectedEffItems(ids);
            } else if (st.defaultEff) {
              setEffValue(st.defaultEff.label);
              setSelectedEffItems([st.defaultEff.key]);
            } else {
              setEffValue('');
              setSelectedEffItems([]);
            }
          }
        });
    }

  };

  const handleClear = () => {
    if ( selectedEff ) {
      let eff = { ...selectedEff};
      if ( eff.effectivity?.length > 0 ) {
        eff.effectivity = [];
      }
      // console.log('CLEAR: ' + eff?.id);
      const param = JSON.stringify(eff);
      const st = editor.current['uxState'];
      editor.current.documentView.executeCommand(XXE.EXECUTE_NORMAL, 'ucs.setEffectivity', param)
        .then(result => {
          if (result?.status === XXE.COMMAND_RESULT_DONE) {
            let done = false;
            if (result?.value) {
              try {
                const effs = JSON.parse(result.value);
                // console.log('setEff value=' + JSON.stringify(effs));
                if (Array.isArray(effs) && effs.length > 0) {
                  const deff = { ...docEff };
                  effs.forEach((seff, index) => {
                    if (index === 0) {
                      eff = seff;
                    }
                    if (seff.id) {
                      // console.log('storing eff id=' + seff.id);
                      deff[seff.id] = seff;
                      st.docEff[eff.id] = seff;
                    }
                  });
                  setDocEff(deff);
                } else {
                  // clear, let the editing context change event reset the context
                  done = true;
                }
              } catch (error) {
                console.log('Error paring setEff value: ' + error);
              }
            } else {
              // clear, let the editing context change event reset the context
              done = true;
            }
            
            setSaveNeeded(true);
            // const st = editor.current['uxState'];
            if (!done) {
              st.selectedEff = eff;
              setSelectedEff(eff);
              // const v = eff.effectivity.reduce((sum, current) => sum !== '' ? sum + ',' + current.value : current.value, '');
              if (st.defaultEff) {
                setEffValue(st.defaultEff.label);
                setSelectedEffItems([st.defaultEff.key]);
              } else {
                setEffValue('');
                setSelectedEffItems([]);
              }
            }
          }
        });

    }

  };

  const renderTreeItem = (item) => {
    /* .filter(item => du.ancestors ? du.ancestors.includes(item.data?.documentId) : true) */
    // console.log('MATCH: ' + JSON.stringify(du.ancestors) + ' : ' + item.data?.documentId);
    return (
      <TreeItem sx={{ padding: '0.5ex' }}
        itemId={item.key}
        label={item.label}
        disabled={false}
        slots={{
          icon: Brightness1Icon
        }}
        slotProps={{
          icon: {
            sx: { color: item.data?.colorValue ? item.data?.colorValue : '#000', paddingRight: '0.5ex' }
          }
        }}

      >
       {Array.isArray(item.children) && item.children.filter(item => du.ancestors ? du.ancestors.includes(item.data?.documentId) : true).map( child => renderTreeItem(child))}
      </TreeItem>
    );
  };

    /* serverurl="ws://localhost:18078/xxe/ws" */
    /* height: 100% */
    return (
      <Box sx={{ height: '100%', width: '100%', display: 'flex', }}>
        <Box sx={{ height: '100%', display: 'grid', gridTemplateRows: showHeader ? '3em 1fr' : '1fr',
             width: rightDrawerOpen ? `calc(100% - ${rightDrawerWidth})` : '100%', transition: 'width 200ms'
        }} >
          {showHeader &&
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: 1, paddingLeft: 2, paddingRight: 2 }}>
              <Typography sx={{ fontWeight: 'bold' }}>{editorLabel}</Typography>
              <Button onClick={() => handleSave()} disabled={!saveNeeded} variant="outlined" startIcon={<SaveAltIcon />}>Save</Button>
            </Box>
          }
          {isFormEnabled ?
            <Paper component={component} elevation="0" ref={editor} sx={{ height: '100%', position: 'relative', width: '100%' }}
              serverurl="ws://localhost:18078/xxe/ws" >
            </Paper> :
            <Paper component={component} elevation="0" ref={editor} sx={{ height: '100%', position: 'relative', width: '100%' }} >
            </Paper>}
        </Box>
        {rightDrawerOpen && 
          <RightEditorPanel editor={editor?.current} enableEff={enableEff} effTree={effTree} onClose={() => setRightDrawerOpen(false)} panelName={rightDrawerPanel} propertyPanel={propertyPanel}
            selectedNode={selectedElement} docAnnot={selectedAnnot} selectedId={selectedId} setDocAnnot={saveSelectedAnnot}
            propertyNode={propertyNode} setPropertyNode={setPropertyNode} du={du} effValue={effValue} setEffValue={setEffValue} setSaveNeeded={setSaveNeeded} docEff={docEff} setDocEff={setDocEff}
            effMap={effMap} selectedEff={selectedEff} setSelectedEff={setSelectedEff} selectedEffItems={selectedEffItems} setSelectedEffItems={setSelectedEffItems} /> }
        <MediaFileChooser open={mediaChooserDialogOpen} onCancel={handleMediaChooserCancel} onSave={handleMediaChooserSave} node={selectedNode}/>
        <InternalLinkChooserDialog document={docId} element={linkInfo} open={internalLinkChooserDialogOpen} onCancel={() => setInternalLinkChooserDialogOpen(false)}
          onSave={handleInternalLinkSave} />
        <ExternalLinkChooserDialog document={docId} element={externalLinkInfo} open={externalLinkChooserDialogOpen} onCancel={() => setExternalLinkChooserDialogOpen(false)}
          onSave={handleExternalLinkSave} />
        <ContentInclusionDialog document={docId} element={contentInclusionInfo} open={contentInclusionDialogOpen} onCancel={() => setContentInclusionDialogOpen(false)} onSave={handleContentInclusionSave}
          value={contentInclusionValue} param={contentInclusionParam} />
        <ChooseFootnoteDialog document={docId} element={footnoteRefInfo} open={footnoteRefChooserDialogOpen} 
          onCancel={() => setFootnoteRefChooserDialogOpen(false)}
          onSave={handleFootnoteRefInfoSave} />
        <CreateTableDialog open={createTableDialogOpen} onCancel={() => setCreateTableDialogOpen(false)} onSave={handleCreateTableSave} />
      </Box>
    );
}

function CloseConfirmDialog (props) {
    const {
        title = 'Close XML Editing Session',
        open,
        onSave,
        onCancel,
        document,
        multiple = false,
        documents = [],
        ...other
    } = props;
    const [okEnabled, setOkEnabled] = useState(false);


    useEffect(() => {
        if ( open  ) {
            setOkEnabled(false);
        } else {
        }
    },[open,document]);


    const onYesClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(true, document, documents);
        }
    };

    const onNoClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(false, document, documents);
        }
    };


    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    return (
      <Dialog
        maxWidth={'900px'}
        open={open}
        onClose={onClose}
        slotProps={{
          paper: {
            sx: {
              minWidth: 600,
              maxWidth: 900,
              maxHeight: 550,
              minHeight: 300,
            }
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
        <DialogContent sx={{ display: 'flex', width: '100%' }}>
          <Box sx={{ display: 'flex', flexFlow: 'column nowrap', alignItems: 'center', justifyContent: 'center', width: '100%', fontSize: '105%' }}>
            <Box sx={{ fontSize: 'inherit' }}>
              <WarningAmberIcon sx={{ fontSize: '30px', color: '#fcba03', marginRight: 1, verticalAlign: 'bottom' }} />
              {multiple ?
                <React.Fragment>
                    <Typography sx={{ display: 'inline', fontSize: 'inherit' }}>{'Files "'}</Typography>
                    {documents.map( (doc, index) => 
                       <React.Fragment>
                          <Typography sx={{ display: 'inline', fontSize: 'inherit', fontWeight: 'bold' }}>{document?.du?.name}</Typography>
                          {index < documents.length - 1 && <Typography sx={{ display: 'inline', fontSize: 'inherit' }}>{index === documents.length - 2 ? ', and' : ', '}</Typography>}
                       </React.Fragment>
                    )};
                    <Typography sx={{ display: 'inline', fontSize: 'inherit' }}>{'" have been modified.'}</Typography>
                </React.Fragment>
                :
                <React.Fragment>
                  <Typography sx={{ display: 'inline', fontSize: 'inherit' }}>{'File "'}</Typography>
                  <Typography sx={{ display: 'inline', fontSize: 'inherit', fontWeight: 'bold' }}>{document?.du?.name}</Typography>
                  <Typography sx={{ display: 'inline', fontSize: 'inherit' }}>{'" has been modified.'}</Typography>
                </React.Fragment>
              }
            </Box>
            <Typography sx={{ fontSize: 'inherit', marginTop: 1 }}>Do you want to save your changes?</Typography>
          </Box>

        </DialogContent>
        <DialogActions sx={{ padding: 3, paddingTop: 1, justifyContent: 'center' }}>
          <Box>
            <Button variant="outlined" onClick={() => onYesClick()} sx={{ minWidth: '7em' }} >Yes</Button>
            <Button variant="outlined" onClick={() => onNoClick()} sx={{ minWidth: '7em', marginLeft: 2 }} >No</Button>
            <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
          </Box>
        </DialogActions>
      </Dialog>
    
        );
    
}


function ReactXMLMultiEditor (props) {
  const {
    name='',
    du, // initial document unit as a DocumentNode object
    readOnly = false,
    closeCallback,
    closeNotify,
    ...other
  } = props;

  const [opened, setOpened] = useState(false);
  const [initialDU, setInitialDU] = useState(null);
  const [tabValue, setTabValue] = useState('');
  const [document, setDocument] = useState('');
  const [workflowInstance, setWorkflowInstance] = useState('');
  const [instanceUpdate, setInstanceUpdate] = useState(20000);
  const [openChooseDocUnitDialog, setOpenChooseDocUnitDialog] = useState(false);
  const [openCloseConfirmDialog, setOpenCloseConfirmDialog] = useState(false);
  const [closeMultiple, setCloseMultiple] = useState(false);
  const [closeConfirmMultiple, setCloseConfirmMultiple] = useState(false);
  const [closeConfirmDocuments, setCloseConfirmDocuments] = useState([]);
  const [docUnitDialogTitle, setDocUnitDialogTitle] = useState('Open XML Document Unit');
  const [docUnitTarget, setDocUnitTarget] = useState('GEN');
  const [closeConfirmDocument, setCloseConfirmDocument] = useState('');
  const [instances, setInstances] = useState([]);
  const [allInstances, setAllInstances] = useState([]); // all instances are never spliced, only added to
  const [currentInstance, setCurrentInstance] = useState(null);
  const [closed, setClosed] = useState(false);
  const [splitMode, setSplitMode] = useState(false);
  const [noCloseAfterSave, setNoCloseAfterSave] = useState(false);
  const [checkinDialogOpen, setCheckinDialogOpen] = useState(false);
  // const instances = useSelector((state) => state.xeditor.instances);
  // const currentInstance = useSelector((state) => state.xeditor.currentInstance);

  const dispatch = useDispatch();

  useEffect( () => {
    const splitUnsub = postal.subscribe(
      'app.menu.window.split',
      (envelope) => {
        setSplitMode(envelope.payload.split);
        if ( envelope.payload.split ) {
          setClosed(false);
        }
      }
    )
    const closeUnsub = postal.subscribe(
      'app.xmleditor.multi.close',
      (envelope) => {
        console.log('received xml editor close notify: ' + JSON.stringify(envelope.payload));
        if ( envelope.payload.close ) {
          closeInstances();
        }
      }
    )
    const closeTabsUnsub = postal.subscribe(
      'app.xmleditor.tabs.close',
      (envelope) => {
        if (envelope.payload.close ) {
          handleConfirmTabCloseAll();
        }
      }
    )
    globalNoCloseWindow = false;
    return () => {
      splitUnsub();
      closeUnsub();
      closeTabsUnsub();
    };
  },[]);

  useEffect(() => {
    if (du) {
      console.log('XML DU: ' + JSON.stringify(du.entry?.lock));
      // dispatch(reduxSetPageName(pname));
      setOpened(false);
      const items = [];
      // dispatch(resetInstances());
      const ro = !du.entry?.lock || du.entry?.lock !== UserInfo.info.name;
      const ccin = du.entry?.lock === UserInfo.info.name;
      const ccout = !du.entry?.lock || du.entry?.lock === '';
      const inst = {id: uuidv4(), needSave: false, du: du, closeAfterSave: false, readOnly: ro, canCheckin: ccin, canCheckout: ccout};
      // dispatch(addInstance(inst));
      items.push(inst);
      globalInstances = items;
      setInstances(items);
      allGlobalInstances = [];
      allGlobalInstances.push(inst);
      setAllInstances(allGlobalInstances);
      setInitialDU(du);
      setCurrentInstance(inst);
      setTabValue(inst.id);
      setDocument(du.document);
      setWorkflowInstance(du.workflowInstance);
      setClosed(false);
      // setSplitMode(false);
      setNoCloseAfterSave(false);
    }

  }, [du]);

  /*
  useEffect( () => {
    console.log('Instances changed: ' + instances.length);

  }, [instances]);
  */

  /*
  useEffect( () => {
    if ( currentInstance?.id ) {
      const inst = instances.find( item => item.id === currentInstance.id);
      if ( inst ) {
        console.log('changing currentInstance to ' + currentInstance?.id);
        setTabValue(currentInstance.id);
      }
    }
  },[currentInstance]);
  */

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    const inst = instances.find(item => item.id === newValue);
    if ( inst ) {
      // dispatch(setCurrentInstance(inst));
      setCurrentInstance(inst);
    }
  };

  const handleConfirmTabCloseAll = () => {
    if ( Array.isArray(globalInstances)) {
      const insts = [...globalInstances];
      const cdocs = [];
      setCloseMultiple(true);
      for(let i=insts.length - 1; i >= 0; i--) {
        // handleTabClose(null, insts[i]);
        if ( insts[i].needSave ) {
          cdocs.push(insts[i]);
        }
      }
      if ( cdocs.length > 1 ) {
        setCloseConfirmDocument(cdocs[0]);
        setCloseConfirmDocuments(cdocs);
        setCloseConfirmMultiple(true);
        setNoCloseAfterSave(true);
        setOpenCloseConfirmDialog(true);
      } else if ( cdocs.length > 0 ) {
        setCloseConfirmDocuments([]);
        cdocs[0].closeAfterSave = false;
        setCloseConfirmDocument(cdocs[0]);
        setCloseConfirmMultiple(false);
        setNoCloseAfterSave(true);
        setOpenCloseConfirmDialog(true);
      } // just confirm don't close
      else {
        postal.publish(
          'app.xmleditor.save.confirmed',
          {
            confirmed: true,
          }
        );
      }
    }
  };

  const handleTabCloseAll = () => {
    if ( Array.isArray(globalInstances)) {
      const insts = [...globalInstances];
      const cdocs = [];
      setCloseMultiple(true);
      for(let i=insts.length - 1; i >= 0; i--) {
        // handleTabClose(null, insts[i]);
        if ( insts[i].needSave ) {
          cdocs.push(insts[i]);
        }
      }
      if ( cdocs.length > 1 ) {
        setCloseConfirmDocument(cdocs[0]);
        setCloseConfirmDocuments(cdocs);
        setCloseConfirmMultiple(true);
        setOpenCloseConfirmDialog(true);
      } else if ( cdocs.length > 0 ) {
        setCloseConfirmDocuments([]);
        cdocs[0].closeAfterSave = true;
        setCloseConfirmDocument(cdocs[0]);
        setCloseConfirmMultiple(false);
        setOpenCloseConfirmDialog(true);
      } else {
        insts.forEach( doc => {
          dispatch(closeAction({id: doc.id}))
          postal.publish('app.xmleditor.close', {id: doc.id});
        });
        closeMultiEditor();
      }

    }
  };

  const handleTabClose = (event, inst) => {
    console.log("closing tab " + inst.id + ', current=' + currentInstance?.id);
    setCloseMultiple(false);
    setCloseConfirmMultiple(false);
    if (inst.needSave) {
      inst.closeAfterSave = false;
      setCloseConfirmDocument(inst);
      setOpenCloseConfirmDialog(true);
    } else {
      // closeInstance(inst, instances);
      dispatch(closeAction({id: inst.id}));
      postal.publish(
        'app.xmleditor.close',
        { id: inst.id}
      );
      // console.log('sending editor closing message: ' + inst.id);
      if ( instances.length < 2 ) {
        globalInstances = [];
        setInstances([]);
        closeMultiEditor();
      }
    }
  };

  const closeInstances = () => {
    console.log('closing xml editor instances...');
    globalInstances.forEach(inst => {
      dispatch(closeAction({ id: inst.id, noCloseWindow: true }));
      postal.publish(
        'app.xmleditor.close',
        { id: inst.id }
      );
      console.log('closing: ' + inst.id);
    });
    globalInstances = [];
    setInstances([]);
  }

  const closeMultiEditor = (options={noCloseWindow: false}) => {
    dispatch(setWorkList({ showList: true, listValue: false }));
    dispatch(setWorkInstance({ showInstance: false, instanceValue: true }));
    setAllInstances([]);
    setInstances([]);
    allGlobalInstances = [];
    globalInstances = [];
    console.log('closeMultiEditor: closed=' + closed + ', options.noCloseWindow=' + options?.noCloseWindow + ', globalNoCloseWindow=' + globalNoCloseWindow );
    if (!closed && !options?.noCloseWindow && !globalNoCloseWindow) {
      WorkflowFrontModule.setCard({
        cmd: 'CLOSE_WINDOW',
        name: 'xmleditor',
      });
      setClosed(true);
    }
    /*
    if (workflowInstance) {
      setInstanceUpdate(instanceUpdate => instanceUpdate + 1);
      const i = instanceUpdate + 1;
      // WorkflowFrontModule.pageChange(<WorkflowInstance instance={workflowInstance} update={i} />, 'instance');
      WorkflowFrontModule.setCard({
        cmd: 'CLOSE_WINDOW', 
        name: 'xmleditor',
      });
    }
    */
  };

  const closeInstance = (inst, itemList, options) => {
    const cinst = currentInstance;
    const items = [...itemList];
    const index = items.findIndex(item => item.id === inst.id);
    // console.log('index to delete: ' + index);
    if (index >= 0) {
      items.splice(index, 1);
      const c = items.find(item => item.id === cinst.id);
      if (!c) {
        if (index < items.length) {
          const nc = items[index];
          if (nc) {
            setCurrentInstance(nc);
            setTabValue(nc.id);
          }
        } else if (items.length > 0) {
          const nc = items[0];
          if (nc) {
            setCurrentInstance(nc);
            setTabValue(nc.id);
          }
        }
      }
      dispatch(closeAction({id: inst.id, noCloseWindow: true}));
      postal.publish(
        'app.xmleditor.close',
        { id: inst.id}
      );
      globalInstances = items;
      setInstances(items);
      if ( items.length === 0 ) {
        console.log('Closing last editor...');
        closeMultiEditor(options);
      } else {
        console.log('Instances remaining: ' + items.length);
      }
    }
  };

  const handleCloseConfirmCancel = () => {
    setOpenCloseConfirmDialog(false);
    postal.publish(
        'app.xmleditor.save.confirmed',
        {
          confirmed: false,
        }
      );
  }

  const handleCloseConfirmSave = (save, inst) => {
    setOpenCloseConfirmDialog(false);
    if ( save && closeConfirmMultiple ) {
      console.log('saving multiple documents: ' + closeConfirmDocuments.length);
      globalConfirmInstances = [];
      if (Array.isArray(closeConfirmDocuments)) {
        closeConfirmDocuments.forEach((inst,index) => {
          inst.closeAfterSave = true;
          inst.confirmAfterSave = index >= (closeConfirmDocuments.length - 1);
          globalConfirmInstances.push(inst);
          dispatch(saveAction({ id: inst.id, noCloseWindow: true }));
        });
        if (!noCloseAfterSave) {
          globalInstances.forEach(inst => {
            if (!inst.closeAfterSave) {
              dispatch(closeAction({ id: inst.id, noCloseWindow: true }));
              postal.publish(
                'app.xmleditor.close',
                { id: inst.id }
              );
            }
          });
        }
      }
      if ( !noCloseAfterSave ) {
        setTimeout(() => closeMultiEditor(), 600);
      }
      setTimeout(() =>
        postal.publish(
          'app.xmleditor.save.confirmed',
          {
            confirmed: true,
          }
        ), 900);
      
    } else if ( save ) {
      console.log('save doc ' + inst?.du?.name + ' : ' + inst.id + ' before closing... noClose=' + noCloseAfterSave);
      inst.closeAfterSave = !noCloseAfterSave;
      inst.confirmAfterSave = true;
      globalConfirmInstances = [];
      globalConfirmInstances.push(inst);
      const items = [...globalInstances];
      const c = items.findIndex(item => item.id === inst.id);
      if ( c >= 0 ) {
        items[c].closeAfterSave = !noCloseAfterSave;
        items[c].confirmAfterSave = true;
      }
      globalInstances = items;
      setInstances(items);
      setCloseConfirmDocument(inst);
      dispatch(saveAction({id: inst.id, closeAfterSave: !noCloseAfterSave, confirmAfterSave: true}));
      /*
      postal.publish(
        'app.xmleditor.close',
        { id: inst.id }
      );
      */
      
      if ( (instances.length < 2 || closeMultiple) && !noCloseAfterSave) {
        setTimeout(() => closeMultiEditor(), 600);
      }
      
      setTimeout(() =>
        postal.publish(
          'app.xmleditor.save.confirmed',
          {
            confirmed: true,
          }
        ), 900);
      
    } else if ( closeConfirmMultiple ) {
      if (!noCloseAfterSave) {
        if (Array.isArray(closeConfirmDocuments)) {
          globalInstances.forEach(inst => {
            dispatch(closeAction({ id: inst.id, noCloseWindow: true }));
            postal.publish(
              'app.xmleditor.close',
              { id: inst.id }
            );
          });
        }
        closeMultiEditor();
      }
      postal.publish(
        'app.xmleditor.save.confirmed',
        {
          confirmed: true,
        }
      );
    } else {
      // console.log('close doc ' + inst?.du?.name + ' without saving...');
      /*
      inst.closeAfterSave = false;
      const items = [...instances];
      const c = items.findIndex(item => item.id === inst.id);
      if ( c >= 0 ) {
        items[c].closeAfterSave = false;
        // setInstances(items); // will be done in close instances
      }
      */
      // closeInstance(inst, items);
      if (!noCloseAfterSave) {
        dispatch(closeAction({ id: inst.id }));
        postal.publish(
          'app.xmleditor.close',
          { id: inst.id }
        );
        if (instances.length < 2) {
          closeMultiEditor();
        }
      }
      postal.publish(
        'app.xmleditor.save.confirmed',
        {
          confirmed: true,
        }
      );
    }
  };

  const handleDocumentSaved = (value, inst) => {
    // console.log('document saved ' + inst?.du?.name + ' : ' + inst.id );
    const ginst = globalConfirmInstances.find ( doc => doc.id === inst.id );
    console.log('closing doc ' + inst?.du?.name + ' : ' + inst.id + ' = ' + inst.closeAfterSave + ' : ' + ginst?.closeAfterSave);
    if ( (inst.closeAfterSave || ginst?.closeAfterSave) && !noCloseAfterSave ) {
      
      // closeInstance(inst, instances);
      inst.closeAfterSave = false;
      dispatch(closeAction({id: inst.id}));
      postal.publish(
        'app.xmleditor.close',
        { id: inst.id}
      );
    }
    console.log('confirm after save: ' + inst.confirmAfterSave + ' : ' + ginst?.confirmAfterSave);
    if ( inst.confirmAfterSave || ginst?.confirmAfterSave ) {
      inst.confirmAfterSave = false;
      postal.publish(
        'app.xmleditor.save.confirmed',
        {
          confirmed: true,
        }
      );
    }
    
  };

  const handleDocumentClosed = (value, inst, options) => {
    console.log('Document close event ' + globalInstances.length );
    closeInstance(inst, globalInstances, options);
  };

  const handleSave = () => {
    dispatch(saveAction({id: currentInstance.id}));
  };

  const handleSaveNeeded = (value, inst) => {
    // console.log('Save needed: ' + inst?.id + ' -> ' + value);
    if (!currentInstance.readOnly) {
      const cinst = { ...currentInstance };
      cinst.needSave = value;
      // dispatch(setCurrentInstance(cinst));
      const items = [...instances];
      const index = items.findIndex(item => item.id === cinst.id);
      if (index >= 0) {
        items[index] = cinst;
      }
      globalInstances = items;
      setInstances(items);
      setCurrentInstance(cinst);
    }
  };

  const handleEditDocUnit = (sinst, action) => {
    setDocUnitTarget(du.targetProfile);
    setOpenChooseDocUnitDialog(true);
  };

  const handleEditDocUnitSave = (info) => {
    setOpenChooseDocUnitDialog(false);
    const ndu = { ...info.node, 
      ancestors: Array.isArray(info.ancestors) ? info.ancestors : [], 
      name: `${info.prefix}${info.title}` };
    ndu.procId = info.procId; // just in case
    ndu.document = document;
    ndu.workflowInstance = workflowInstance;
    if ( info.targetProfile ) {
      ndu.targetProfile = info.targetProfile;
    } else {
      ndu.targetProfile = initialDU.targetProfile;
    }
    // WorkflowModule.pageChange(<ReactXMLEditor du={du} name={`${info.prefix}${info.title}`} component="ux-xxe-client-wrapper" />, 'xmleditor');
    // WorkflowModule.pageChange(<ReactXMLMultiEditor du={du} />, 'xmleditor');
    const ro = !ndu.entry?.lock || ndu.entry?.lock !== UserInfo.info.name;
    const ccin = ndu.entry?.lock === UserInfo.info.name;
    const ccout = !ndu.entry?.lock || ndu.entry?.lock === '';
    const inst = {id: uuidv4(), needSave: false, du: ndu, readOnly: ro, canCheckin: ccin, canCheckout: ccout};
    const items = [...globalInstances];
    items.push(inst);
    allGlobalInstances.push(inst);
    globalInstances = items;
    setInstances(items);
    setAllInstances(allGlobalInstances);
    setCurrentInstance(inst);
    setTabValue(inst.id);
    setClosed(false);
    // dispatch(addInstance(inst));
  };

  const handleCheckin = () => {
    setCheckinDialogOpen(true);
  };

  const handleCheckinSave = (message, item) => {
    setCheckinDialogOpen(false);
    const cinst = { ...currentInstance };
    if (cinst.du) {
      if (cinst.du.entry?.lock === UserInfo.info.name) {
        const pentry = cinst.du.entry ? cinst.du.entry : {};
        // console.log('parent: ' + JSON.stringify(pentry));
        const info = {
          eid: pentry.entryId,
          docId: document,
          entry: { ...pentry },
          message: message,
        };
        // console.log('delete file: ' + JSON.stringify(info));

        netPost('/api/doc/entry/checkin', info).then(response => {
          if (!response.ok) {
            console.log('Could not checkin file: error = ' + response.status);
          } else {
            console.log('Checkin file ' + pentry.entryId);
            
            cinst.du.entry.lock = null;
            cinst.canCheckin = false;
            cinst.canCheckout = true;
            cinst.readOnly = true;
            const items = [...instances];
            const index = items.findIndex(item => item.id === cinst.id);
            if (index >= 0) {
              items[index] = cinst;
            }
            globalInstances = items;
            setInstances(items);
            setCurrentInstance(cinst);

            const aitems = [...allInstances];
            const aindex = aitems.findIndex(item => item.id === cinst.id);
            if ( aindex >= 0 ) {
              aitems[aindex] = cinst;
            }
            allGlobalInstances = aitems;
            setAllInstances(aitems);

            postal.publish(
              "xmleditor.checkin.event",
              {
                eid: pentry.entryId,
                id: pentry.id,
                docId: document,
                value: {action: cinst.du.action, index: cinst.du.actionIndex, 
                  wid: cinst.du.workflowInstance?.id, sid: cinst.du.workflowInstance?.stepId}
              }
            );
          }
        });
      }
    }
  };

  const handleRevoke = () => {
    const cinst = { ...currentInstance };
    if (cinst.du) {
      if (cinst.du.entry?.lock === UserInfo.info.name) {
        const pentry = cinst.du?.entry ? cinst.du.entry : {};
        // console.log('parent: ' + JSON.stringify(pentry));
        const info = {
          eid: pentry.entryId,
          docId: document,
          entry: { ...pentry },
        };
        // console.log('delete file: ' + JSON.stringify(info));

        netPost('/api/doc/entry/revoke', info).then(response => {
          if (!response.ok) {
            console.log('Could not revoke checkout file: error = ' + response.status);
          } else {
            console.log('Revoke checked out file ' + pentry.entryId);
            
            cinst.du.entry.lock = null;
            cinst.canCheckin = false;
            cinst.canCheckout = true;
            cinst.needSave = false;
            cinst.readOnly = true;
            const items = [...instances];
            const index = items.findIndex(item => item.id === cinst.id);
            if (index >= 0) {
              items[index] = cinst;
            }
            globalInstances = items;
            setInstances(items);
            setCurrentInstance(cinst);

            const aitems = [...allInstances];
            const aindex = aitems.findIndex(item => item.id === cinst.id);
            if ( aindex >= 0 ) {
              aitems[aindex] = cinst;
            }
            allGlobalInstances = aitems;
            setAllInstances(aitems);
          }
        });
      }
    }
  };

  const handleCheckout = () => {


    const cinst = { ...currentInstance };

    if  ( cinst.du ) {
      if (!cinst.du.entry?.lock) {
        const pentry = cinst.du.entry ? cinst.du.entry : {};
        // console.log('parent: ' + JSON.stringify(pentry));
        const info = {
          eid: pentry.entryId,
          docId: document,
          entry: { ...pentry },
        };
        // console.log('delete file: ' + JSON.stringify(info));

        netPost('/api/doc/entry/checkout', info).then(response => {
          if (!response.ok) {
            console.log('Could not checkout file: error = ' + response.status);
          } else {
            console.log('Checked out file ' + pentry.entryId);

            cinst.du.entry.lock = UserInfo.info.name;
            cinst.canCheckin = true;
            cinst.canCheckout = false;
            cinst.readOnly = false;
            const items = [...instances];
            const index = items.findIndex(item => item.id === cinst.id);
            if (index >= 0) {
              items[index] = cinst;
            }
            globalInstances = items;
            setInstances(items);
            setCurrentInstance(cinst);

            const aitems = [...allInstances];
            const aindex = aitems.findIndex(item => item.id === cinst.id);
            if ( aindex >= 0 ) {
              aitems[aindex] = cinst;
            }
            allGlobalInstances = aitems;
            setAllInstances(aitems);
            
          }
        });
      }
    }


    // dispatch(setCurrentInstance(cinst));
    

  };

  const getInstanceLabel = (inst) => {
    let label = inst.du?.name;
    if ( inst.readOnly ) {
      label = label + " [r/o]";
    } else if ( inst.needSave ) {
      label = label + "*";
    }
    return label;
  }

  return (
    <Box sx={{height: '100%', display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', alignItems: 'stretch', justifyContent: 'space-between'}}>

        <TabContext value={tabValue} variant="scrollable"
                    scrollButtons="auto">
          <Box sx={{display: 'flex', justifyContent: 'space-between', padding: 0, paddingLeft: 1, paddingRight: 1, alignItems: 'flex-end' }}>
            <Button onClick={() => handleEditDocUnit()} variant="outlined" startIcon={<OpenInBrowserIcon />} size="small" sx={{marginBottom: '6px', marginRight: 1}}>Open</Button>
            <TabList onChange={handleTabChange} aria-label="XML Editor Tabs" sx={{flexGrow: 1, paddingLeft: '4px'}} variant="scrollable" scrollButtons="auto" >
              {Array.isArray(instances) && instances.map( inst =>
                <Tab label={getInstanceLabel(inst)} value={inst.id} sx={{paddingTop: 1, paddingBottom: 0, minHeight: "54px", textTransform: 'none', }}
                  icon={<IconButton onClick={(event) => handleTabClose(event, inst)} size="small" sx={{fontSize: '0.9rem', color: 'inherit'}}><CloseIcon fontSize="small" sx={{fontSize: '1rem', color: 'inherit'}}/></IconButton>}
                  iconPosition="end" />
              )}
            </TabList>
            {currentInstance?.canCheckin &&
              <React.Fragment>
                <Button onClick={() => handleCheckin()} disabled={!currentInstance?.canCheckin || currentInstance?.needSave} variant="outlined"
                  startIcon={<ExitToAppIcon />} size="small" sx={{ marginBottom: '6px', mr: 2 }} >Checkin</Button>
                <Button onClick={() => handleRevoke()} disabled={!currentInstance?.canCheckin} variant="outlined"
                  startIcon={<ReplayIcon />} size="small" sx={{ marginBottom: '6px', mr: 2 }} >Revoke Checkout</Button>
              </React.Fragment>
            }
            {currentInstance?.canCheckout &&
                <Button onClick={() => handleCheckout()} disabled={!currentInstance?.canCheckout} variant="outlined"
                  startIcon={<OutputIcon />} size="small" sx={{ marginBottom: '6px', mr: 2 }} >Checkout</Button>
            }
            <Button onClick={() => handleSave()} disabled={!currentInstance?.needSave || currentInstance?.readOnly} variant="outlined" 
              startIcon={<SaveAltIcon />} size="small" sx={{marginBottom: '6px'}} >Save</Button>
            <IconButton sx={{marginLeft: 3}} onClick={handleTabCloseAll}>
              <CloseIcon/>
            </IconButton>
          </Box>
          {Array.isArray(allInstances) && allInstances.map(inst =>
            <TabPanel value={inst.id} sx={{flexGrow: 1, padding: 0, paddingTop: '8px'}} keepMounted >
              <ReactXMLEditor du={inst.du} eid={inst.id} showHeader={false} component="ux-xxe-client-wrapper" rightDrawerTop="116px" 
                  onSaveNeeded={(value) => handleSaveNeeded(value, inst)} readOnly={inst.readOnly}
                  onSaved={(value) => handleDocumentSaved(value, inst)} 
                  onClosed={(value, options) => handleDocumentClosed(value, inst, options)} />
            </TabPanel>
          )}
        </TabContext>
        
        <ChooseDocumentUnitDialog open={openChooseDocUnitDialog} title={docUnitDialogTitle} instance={workflowInstance} document={document} 
                        onCancel={() => setOpenChooseDocUnitDialog(false)} target={docUnitTarget}
                        onSave={handleEditDocUnitSave} />
        <CloseConfirmDialog open={openCloseConfirmDialog} document={closeConfirmDocument} onCancel={handleCloseConfirmCancel}
            onSave={handleCloseConfirmSave} multiple={closeConfirmMultiple} documents={closeConfirmDocuments} />
        <CheckinDialog open={checkinDialogOpen} onCancel={() => setCheckinDialogOpen(false)} node={currentInstance?.du} 
                    onSave={handleCheckinSave} />
    </Box>
  );
}

export { ReactXMLEditor, ReactXMLMultiEditor, xmlEditorCloseCallback };